import { he } from "date-fns/locale";

export const hindiTranslations = {
  agentGrm: {
    ADD_DETAILS: "विवरण जोड़ें",
    CATEGORY: "वर्ग",
    COMMON_SUB_CATEGORY: "उपश्रेणी",
    COMMON_SUB_SUB_CATEGORY: "उप-उप-श्रेणी",
    GRIEVANCE_SUBJECT: "उप-उप-श्रेणी",
    grmApplication: "जीआरएम आवेदन",
    grmApplicationSubText: "वह श्रेणी चुनें जिसके अंतर्गत आपकी शिकायत आती है",
    selectCategoryType: "वर्ग चुनें",
    selectSubCategoryType: "उपश्रेणी, उप-उप-श्रेणी चुनें",
    categoryType: "वर्ग प्रकार",
    governmentSchemesRelated: "सरकारी योजनाएँ संबंधित सेवाएँ",
    privateSchemeRelated: "निजी योजनाएँ संबंधित सेवाएँ",
    governmentSR: "सरकारी सेवाओं से संबंधित",
    privateSR: "निजी क्षेत्र से संबंधित सेवाएँ",
    SELECT_SUB_CATEGORY: "उपश्रेणी चुनें",
    SELECT_SUB_SUB_CATEGORY: "उप-उप-श्रेणी चुनें",
    SELECTED_FILES: "अपलोड की गई फ़ाइलें",
    SUB_CATEGORY: "उपश्रेणी",
    WRITE_COMMENTS: "अपनी टिप्पणियाँ लिखें",
    UPLOAD_FILES: "फाइलें अपलोड करें",
    GRM_CREATE_SUCCESS_MSG: "शिकायत सफलतापूर्वक उठाई गई है",
    GRM_TICKET_NUMBER: "टिकट संख्या",
    COMMON_RESEND_ANOTHER_OTP: "नहीं मिला??",
    COMMON_RESEND_ANOTHER_OTP_TAIL: "सेकंड में पुनः भेजें",
    GRM: "जीआरएम",
    GRM_APPLICATION: "जीआरएम एप्लीकेशन",
    CATEGORY_SELECTION_ERROR: "कृपया वर्ग चुनें",
    SUB_CATEGORY_SELECTION_ERROR: "कृपया उपश्रेणी चुनें",
    SUB_SUB_CATEGORY_SELECTION_ERROR: "कृपया उप-उप-श्रेणी चुनें",
    SUBMIT: "ज़मा करें",
  },
  agentTrack: {
    GRM_TICKET_NUMBER: "टिकट संख्या",
    SCHEME_TICKET_NUMBER: "आवेदन संख्या",
    TRACK_SERVICE: "ट्रैक सेवा",
    TRACK_SERVICE_SUBTEXT:
      "वह सेवा चुनें जिसके अंतर्गत आप ट्रैक करना चाहते हैं",
    GRM_TICKET_NUMBER_ENTER:
      "कृपया टिकट नंबर दर्ज करें जिसे आप ट्रैक करना चाहते हैं",
    SCHEME_TICKET_NUMBER_ENTER:
      "कृपया वह एप्लिकेशन नंबर दर्ज करें जिसे आप ट्रैक करना चाहते हैं",
    SELECT_TRACK_OPTION: "कृपया वह विकल्प चुनें जिसे आप ट्रैक करना चाहते हैं",
    TRACK: "ट्रैक",
    TRACK_GRM: "जीआरएम",
    TRACK_SCHEME: "योजना",
    TICKET_VALIDATION_ERROR: "कृपया वैध टिकट संख्या दर्ज करें",
    SERVICE_VALIDATION_ERROR: "कृपया सेवा चुनें",
  },
  schemeTrack: {
    SCHEMES_TRACK: "योजना आवेदन विवरण",
  },
  appBar: {
    home: "होम स्क्रीन",
    aboutUs: "हमारे बारे में",
    schemes: "कार्यक्रम एवं योजनाएँ",
    majorCrops: "प्रमुख फसलें",
    logout: "लॉग आउट",
    welcome: "स्वागत हे!",
  },
  home: {
    Dashboard: "डैशबोर्ड",
    Schemes: "योजनाओं",
    homePageCards: {
      newFarmers: "नये किसानों का पंजीयन हुआ",
      applications: "योजनाओं के लिए आवेदन जमा किये गये",
    },
    Advisory: "सलाहकार",
    Marketplace: "बाजार",
    Grievance: "शिकायत",
    Insurance: "बीमा",
    Credit: "श्रेय",
    ENTER_OTP: "ओटीपी दर्ज करें",
  },
  schemes: {
    // Same key names + copy as rp-revamp-scheme-3547-handoff.
    cantRememberDbtId: "क्या आपको अपनी डीबीटी आईडी याद नहीं है?",
    recover: "पुनः प्राप्त करें",
    dontHaveDbtId: "आपके पास डीबीटी आईडी नहीं है?",
    registerNow: "अभी पंजीकरण करें",
    allschemes: "योजनाएँ",
    myschemes: "मेरी योजनाएँ",
    searchSchemes: "योजनाएँ खोजें",
    showingResultsPage: "प्रति पृष्ठ पर अधिकतम {{results}} परिणाम दिखा रहे हैं",
    more: "अधिक",
    apply: "आवेदन करें",
    save: "सहेजें & आगे",
    back: "पीछे",
    close: "बंद करे",
    applyEligibilityFallbackMessage:
      "आपका पूर्व में जमा किया गया आवेदन प्रक्रिया में है। कृपया आगे की सूचना के लिए प्रतीक्षा करें।",
    registrationForm: "पंजीकरण फार्म",
    agricultureSchemes: "कृषि योजनाएँ",
    fisheriesSchemes: "मत्स्य पालन योजनाएँ",
    horticultureSchemes: "बागवानी योजनाएँ",
    small: "छोटा",
    medium: "मध्यम",
    large: "बड़ा",
    "<2acres": "<2 एकड़",
    "2-5acres": "2-5 एकड़",
    ">5acres": ">5 एकड़",
    schemeTypes: "योजनाओं",
    farmerTypes: "किसान वर्ग",
    landSize: "भूमि सीमा",
    appliedBeeScreenError:
      "मधु निष्काशन यन्त्र तथा फूड ग्रेड कंटेनर में से किसी एक अवयव का ही लाभ लिया जा सकता है। कृपया किसी एक के लिए हाँ का चयन करें",
    schemesForFarmers: "किसानों के लिए योजनाएँ",
    schemeDetails: "योजना का विवरण",
    schemeKnowMore: "और जानें",
    filterBy: "फ़िल्टर करें",
    sortBy: "क्रमबद्ध करें",
    stateScheme: "राज्य योजनाएँ",
    centralSponsored: "केंद्रीय प्रायोजित योजनाएँ",
    centralScheme: "केंद्रीय योजनाएँ",
    centralCredit: "केंद्रीय ऋण योजनाएँ",
    governmentSchemes: "सरकारी योजनाएँ",
    recommendedSchemes: "अनुशंसित योजनाएँ",
    categoryFilter: "श्रेणियाँ",
    allCategories: "सभी श्रेणियाँ",
    searchPlaceholder: "योजनाएँ खोजें",
    filtersAria: "योजना फ़िल्टर",
    directorateAria: "निदेशालय अनुसार फ़िल्टर करें",
    searchGroupHeading: "योजनाएँ",
    searchResultsAria: "योजना खोज परिणाम",
    searchNoResults: "कोई परिणाम नहीं मिला।",
    appliedSchemes: "आवेदित योजनाएँ",
    appliedSchemesCountNote: "({{count}} योजनाओं के लिए आवेदन किया गया है)",
    recommendedEmpty: "अभी आपके लिए कोई पात्र योजना नहीं मिली।",
    recommendedAgentPending:
      "सहायता मोड में इस किसान के लिए अनुशंसित योजनाएँ अभी उपलब्ध नहीं हैं।",
    // Shared "no results" panel (Figma 639-51479) — SchemesEmptyState.
    goToSchemesPage: "योजना पृष्ठ पर जाएं",
    allSchemesEmptyTitle: "कोई योजना नहीं मिली",
    allSchemesEmptySubtitle: "आपके चुने गए फ़िल्टर से कोई योजना मेल नहीं खाती।",
    recommendedEmptyTitle: "कोई अनुशंसित योजना नहीं",
    applied: {
      // Status pill label, keyed on the raw application.status value (closed set).
      status: {
        SUBMITTED_SUCCESSFULLY: "लंबित",
        PENDING: "लंबित",
        REQUEST_IN_PROCESS: "प्रक्रियाधीन",
        APPROVED: "स्वीकृत",
        REJECTED: "अस्वीकृत",
        INVALID_APPLICATION: "अमान्य आवेदन",
        DUPLICATE_APPLICATION: "डुप्लिकेट आवेदन",
        FAILED: "विफल",
        default: "अमान्य आवेदन",
      },
      appliedOn: "आवेदन तिथि",
      applicationNumber: "आवेदन संख्या",
      downloadForm: "फ़ॉर्म डाउनलोड करें",
      downloadError: "फ़ाइल डाउनलोड नहीं हुई",
      sortRecent: "सबसे नए",
      pageTitle: "आवेदित योजना",
      detailsPageTitle: "आवेदित योजना विवरण",
      source: "स्रोत",
      updatedOn: "अद्यतन तिथि",
      statusTimelineTitle: "स्थिति",
      appliedSchemeStep: "आवेदित योजना",
      statusReason: "कारण: {{reason}}",
      kisanCallCentre: "किसान कॉल सेंटर :",
      copyNumber: "नंबर कॉपी करें",
      numberCopied: "नंबर कॉपी हो गया",
      emptyTitle: "कोई योजना आवेदित नहीं",
      emptySubtitle: "इस रिकॉर्ड के लिए कोई योजना आवेदित नहीं की गई है।",
    },
    sortAll: "सभी",
    sortNew: "नई",
    sortClosingSoon: "जल्द समाप्त होने वाली",
    showingOfItems: "{{total}} में से {{count}} दिखाई जा रही हैं",
    directorate: {
      all: "सभी",
      horticulture: "बागवानी",
      agriculture: "कृषि",
      fisheries: "मत्स्य पालन",
      soilConservation: "मृदा संरक्षण",
    },
    applicationWindow: "आवेदन विंडो",
    schemeAbout: "योजना के बारे में जानकारी",
    schemeGuidelines: "योजना दिशानिर्देश",
    guidelines: "दिशानिर्देश",
    schemeApplyNow: "आवेदन करें",
    schemeVerifyFarmer: "अपना खाता सत्यापित करें",
    schemeVerifyFarmerSubtext:
      "कृपया आगे बढ़ने से पहले किसान डीबीटी विवरण सत्यापित करें",
    farmerDBTId: "किसान का डीबीटी आईडी नंबर दर्ज करें",
    farmerMobileNumber: "किसान का मोबाइल नंबर दर्ज करें",
    farmerDBTIdPlaceholder: "डीबीटी आईडी दर्ज करें",
    farmerMobileNumberPlaceholder: "मोबाइल नंबर दर्ज करें",
    verifyUsing: "सत्यापन का तरीका",
    verifyByDbtId: "डीबीटी आईडी",
    verifyByMobile: "मोबाइल नंबर",
    editMobileNumber: "मोबाइल नंबर संपादित करें",
    otpSentMessage:
      "एक ओटीपी किसान के पंजीकृत मोबाइल नंबर पर भेजा गया है, जो {{mobile}} पर समाप्त होता है",
    memberOtpSentMessage:
      "एक ओटीपी सदस्य के पंजीकृत मोबाइल नंबर पर भेजा गया है",
    getOTP: "ओटीपी जनरेट करें",
    sendingOTP: "ओटीपी भेजा जा रहा है..",
    otpVerifieng: "ओटीपी सत्यापन...",
    otpSuccess: "ओटीपी भेजा गया!",
    otpFailed: "ओटीपी विफल हुआ!!",
    enterOTP: "ओटीपी दर्ज करें",
    verify: "ओटीपी सत्यापित करें",
    resendOtp: "ओटीपी पुनः भेजें",
    resendOtpIn: "प्राप्त नहीं हुआ? {{time}}s में पुनः प्रयास करें",
    confirmCancel: "किसान लॉग आउट हो जायेगा!! क्या आप यह चाहते हैं??",
    confirmNavigation:
      "यदि लॉग इन है तो किसान लॉग आउट हो जाएगा। क्या आप सुनिश्चित हैं??",
    confirmCancelTitle: "क्या आप वाकई स्कीम आवेदन रद्द करना चाहते हैं?",
    confirmCancelSubtext: "सारी प्रगति मिट जाएगी।",
    confirmCancelYes: "हाँ, रद्द करें",
    confirmCancelNo: "नहीं, जारी रखें",
    confirmCategorySwitchTitle: "क्या आप वाकई श्रेणी बदलना चाहते हैं?",
    confirmCategorySwitchSubtext:
      "इस आवेदन के लिए दर्ज की गई सभी जानकारी मिट जाएगी।",
    confirmCategorySwitchYes: "हाँ, बदलें",
    applicationSubmittedTitle: "{{schemeName}} आवेदन सफलतापूर्वक जमा हो गया!",
    applicationSubmittedSubtitle:
      "आपका स्कीम आवेदन जमा कर दिया गया है। हमारी टीम इसकी समीक्षा कर जल्द ही आपसे संपर्क करेगी।",
    applicationIdLabel: "आईडी: {{id}}",
    copyApplicationId: "आवेदन आईडी कॉपी करें",
    applicationIdCopied: "आवेदन आईडी कॉपी हो गई",
    downloadSchemePdf: "स्कीम PDF डाउनलोड करें",
    appliedOnLabel: "आवेदन तिथि : {{date}}",
    viewAppliedScheme: "आवेदित स्कीम देखें",
    applicationTypeRequired: "कृपया आवेदक का प्रकार चुनें।",
    createSchemeApplication: "स्कीम फॉर्म भरें",
    enterDetailsForFarmerApplication:
      "किसान आवेदन बनाने के लिए निम्नलिखित जानकारी भरें।",
    applicationForm: "आवेदक का प्रकार चुनें",
    selectCategory: "श्रेणी चुनें",
    individualDesc: "अपनी भूमि पर लाभ के लिए एकल किसान के रूप में आवेदन करें।",
    groupDesc:
      "लाभ सामूहिक रूप से प्राप्त करने के लिए किसानों के समूह (FPO/SHG/सहकारी) के रूप में आवेदन करें।",
    open: "आवेदन चालू",
    closed: "आवेदन बंद",
    new: "नया",
    alreadyApplied: "आवेदन किया गया",
    viewDetails: "विवरण देखें",
    breadcrumbSchemeDetails: "योजना विवरण",
    breadcrumbApplyScheme: "योजना के लिए आवेदन",
    breadcrumbPreview: "विवरण पूर्वावलोकन",
    endsOn: "समाप्ति: {{date}}",
    period: "अवधि: {{range}}",
    closesToday: "आज बंद हो रहा है",
    closesInDay: "1 दिन में बंद होने वाला है",
    closesInDays: "{{count}} दिनों में बंद होने वाला है",
    latest: "नवीनतम",
    default: "डिफ़ॉल्ट",
    gramUnit: "ग्राम",
    kilogramUnit: "किलो ग्राम",
    sortAlphAsc: "अ -> ज्ञ",
    sortAlphDesc: "ज्ञ -> अ",
    noSchemes: "कोई योजना उपलब्ध नहीं है",
    fetchingLocationData: "स्थान संबंधी जानकारी प्राप्त की जा रही है...",
    locationDataLoaded: "स्थान संबंधी जानकारी सफलतापूर्वक प्राप्त हो गई है",
    addRecord: "रिकॉर्ड जोड़ें",
    removeRecord: "रिकॉर्ड हटाएँ",
    submit: "ज़मा करें",
    confirmLandDetails:
      "{{component}} के डेटा साफ़ कर दिए जाएंगे। क्या आप सुनिश्चित हैं?",
    farmerConsent:
      "मैं इस द्वारा घोषणा करता हूँ कि मैं किसान की ओर से यह आवेदन भर रहा हूँ और ऊपर दी गई सभी जानकारी सही है। यदि इनमें से कोई भी जानकारी गलत पाई जाती है, तो मैं इस आवेदन के अस्वीकृति के लिए जिम्मेदार रहूँगा और सब्सिडी राशि किसान से वसूली जा सकती है, जिसके लिए मैं दंडात्मक कार्यवाही के लिए उत्तरदायी रहूँगा।",
    preview: "पूर्वावलोकन",
    cancel: "रद्द करें",
    previous: "पीछे जाएँ",
    next: "आगे बढ़ें",
    saveContinue: "सहेजकर आगे बढ़ें",
    savePreview: "सहेजें और जारी रखें",
    personalDetails: "व्यक्तिगत जानकारी",
    chooseFilesToUpload: "अपलोड करने के लिए फ़ाइलें चुनें",
    autoFilledFromDbt: "DBT से स्वतः भरा गया",
    stepAriaLabel: "चरण {{n}} / {{total}}: {{label}}",
    scrollStepsLeft: "चरण बाईं ओर स्क्रॉल करें",
    scrollStepsRight: "चरण दाईं ओर स्क्रॉल करें",
    yes: "हाँ",
    no: "नहीं",
    totalArea: "कुल रकवा",
    totalAppliedArea: "कुल आवेदित रकवा",
    totalAreaAcre: "कुल रकवा - {{area}} एकड़",
    totalAppliedAreaAcre: "कुल आवेदित रकवा - {{area}} एकड़",
    seedQuantity: "बीज की मात्रा - {{quantity}} {{unit}}",
    remove: "हटाएं",
    submitApplication: "आवेदन जमा करें",
    documentPreview: "अपलोड की गई फाइलें",
    editForm: "फॉर्म संपादित करें",
    addressDetailsPreview: "पता विवरण",
    homePage: "होमपेज",
    SCHEME_CREATE_MESSAGE: "आवेदन सफलतापूर्वक जमा कर दिया गया है",
    schemeCreated: "आवेदन की तिथि : {{date}}",
    schemeNumber: "आवेदन संख्या: {{number}}",
    applicationStatus: "स्थिति: {{status}}",
    fileSizeInfo: "अधिकतम फ़ाइल आकार: 2MB",
    alreadyAppliedSeed: "किसान के द्वारा आवेदन किया जा चुका है।",
    documentContentEmpty:
      "इस अनुभाग के लिए वर्तमान में कोई सामग्री उपलब्ध नहीं है। आप अपडेट के लिए बाद में पुनः जांच सकते हैं।",
    selectSeasonSeed: "फसल सत्र चुनें",
    seedTable: {
      code: "कोड",
      scheme: "योजना",
      schemeComponent: "योजना का घटक",
      crop: "फसल",
      cropVariety: "फसल की किस्म",
      seedType: "बीज प्रकार",
      rate: "दर",
      grantPercent: "अनुदान ( % )",
      grantPerKg: "अनुदान / कि०ग्रा०",
      maxLimit: "अधिकतम सीमा",
      apply: "आवेदन करें",
    },
    unableToFetchSubSchemes: "उप-योजनाओं की जानकारी नहीं मिल पाई। कृपया दोबारा प्रयास करें।",
    paginationTitle: "प्रति पृष्ठ अधिकतम {{count}} परिणाम दिखाए जा रहे हैं",
    type: "प्रकार",
    name: "नाम",
    individualBorvelWork: "Borewell का कार्य ",
    schemeSubName: "योजना",
    cropCode: "योजना कोड",
    bananaCols: {
      S_No: "क्र०सं०",
      strain: "प्रभेद",
      appliedAreaFor: "आवेदित रकवा(एकड़ में)*",
    },
    trackingNumber: "ट्रैकिंग टिकट संख्या",
    NOFORM:
      "आवेदन फॉर्म इस समय उपलब्ध नहीं है। कृपया बाद में पुनः प्रयास करें।",
    applyEligibilityClosed:
      "यह योजना अब आवेदन स्वीकार नहीं कर रही है।",
    INVALIDURL: "आवेदन पृष्ठ खोलने में असमर्थ। कृपया बाद में पुनः प्रयास करें।",
    dbtRequiredTitle: "लाभ प्राप्त करने के लिए अपनी डीबीटी आईडी सिंक करें।",
    dbtRequiredCta: "डीबीटी आईडी दर्ज करें",
  },

  schemeErrors: {
    fieldIsRequired: "यह फ़ील्ड अनिवार्य है",
    invalidEmail: "अमान्य ईमेल पता",
    invalidIntegerFormat: "अमान्य पूर्णांक संख्या प्रारूप",
    invalidDecimalFormat: "अमान्य दशमलव संख्या प्रारूप",
    minLengthError: "न्यूनतम आवश्यक लंबाई {{length}} है",
    maxLengthError: "केवल अधिकतम {{length}} वर्ण की अनुमति है",
    minValueError: "कुल संख्या {{min}} से कम नहीं होना चाहिए",
    maxValueError: "कुल संख्या {{max}} से अधिक नहीं होना चाहिए",
    totalAreaExceedsMax: "कुल क्षेत्रफल {{max}} एकड़ से अधिक नहीं होना चाहिए",
    appliedAreaExceedsTotal: "आवेदित क्षेत्रफल कुल क्षेत्रफल से कम होना चाहिए",
    totalAreaError: "कुल रकवा {{max}} से अधिक नहीं होना चाहिए",
    totalAreaMinError: "कुल रकवा {{min}} से कम नहीं होना चाहिए",
    totalAppliedAreaError: "कुल आवेदित रकवा {{max}} से अधिक नहीं होना चाहिए",
    totalAreaShuskError:
      "जमीन के विवरण से ज्यादा रकवा में आवेदन दर्ज नहीं कर सकते हैं",
    checkboxRequired: "कृपया चेकबॉक्स चुनें",
    radioRequired: "एक का चयन करें",
    fileRequired: "कोई फ़ाइल चयनित नहीं है",
    appliedAcreageError:
      "आवेदित रकवा ({{floatVal}}) को कुल रकवा ({{totalArea}}) से ज्यादा नहीं किया जा सकता",
    districtNotEligible: "किसान के जिले में यह योजना अभी लागू नहीं है",
    pmksyError:
      "PMKSY योजना समूहों के लिए सहायक मोड में उपलब्ध नहीं है। कृपया जारी रखने के लिए 'व्यक्तिगत' चुनें।",
    addNewRowError: "कृपया पिछली प्रविष्टि भरें/जमा करें।",
    addNewRowPreviewError: "कृपया प्रविष्टि जमा करें।",
    pleaseEnterValueMin: "कृपया {{min}} या उससे अधिक प्रविष्टियां करें",
    duplicateReturnPolicy: "कृपया एक अलग मान दर्ज करें",
    litchiOnlyRaiyat: "केवल रैयत किसान ही लीची घटक के लिए आवेदन कर सकते हैं",
  },
  COMMON_EDIT: "संपादित करें",
  COMMON_BACK: "वापस",
  COMMON_RESEND_OTP: "प्राप्त नहीं हुआ? ओटीपी पुनः भेजें",
  SESSION_EXPIRE_ERROR:
    "आपका सत्र समाप्त हो गया है। कृपया जारी रखने के लिए लॉग इन करें।",
  SCHEME_BENEFITS: "योजना के लाभ",
  SCHEME_HAS_ERRORS:
    "कृपया योजना का पूर्वावलोकन करने से पहले आवश्यक फ़ील्ड भरें। सुनिश्चित करें कि सभी फ़ील्ड सही तरीके से भरे गए हैं।",
  SCHEME_APPLICATION_CREATE_ERROR:
    "यह आवेदन इस समय प्रस्तुत नहीं किया जा सकता। कृपया बाद में फिर से जांचें।",
  SCHEME_APPLICATION_NOT_FOUND: "योजना आवेदन प्राप्त नहीं हुआ",
  REQUEST_IN_PROCESS: "अनुरोध प्रगति पर है",
  SUBMITTED_SUCCESSFULLY: "आवेदन सफलतापूर्वक जमा हो चुका है",
  FAILED: "आवेदन असफल हो चुका है",
  REJECTED_TRACK: "आवेदन अस्वीकृत हो चुका है",
  SCHEME_DOWNLOAD_RECIEPT: "रसीद देखें और डाउनलोड करें",
  AllContacts: "सभी संपर्क देखें",
  Login: "लॉग इन",
  CantLogin: "पासवर्ड भूल गए?",
  AGENT_FARMER_REGISTRATIONS: "किसान पंजीकरण",
  AGENT_GRM_REQUESTS: "जीआरएम अनुरोध उठाए गए",
  AGENT_SCHEMES_APPLIED: "लागू योजनाएँ",
  BENIFICIARY_ID: "लाभार्थी आईडी",
  BENIFICIARY_NAME: "लाभार्थी किसान का नाम",
  copyright: "कॉपीराइट",
  DATE_TIME: "तिथि और समय",
  DFSWEB_AGENT: "एजेंट",
  DFSWEB_ASSETS: "कृषि संसाधन",
  Policy: "नीति",
  AccessibilityStatement: "सुगम्यता वक्तव्य",
  DFSWEB_LOGIN_PAGE: "लॉग इन",
  DFSWEB_ASSETS_details: "कृषि संसाधन विवरण",
  ASSETS_CATEGORY_NOT_FOUND: "इस श्रेणी के लिए कोई संसाधन नहीं मिला",
  DFSWEB_CAROUSEL: "बिहार कृषि वेब कैरोसेल",
  COMMON_CLOSE: "बंद करें",
  COMMON_DONE: "हो गया",
  COMMON_NEXT: "आगे बढ़ें",
  COMMON_SCROLL_LEFT: "बाईं ओर स्क्रॉल करें",
  COMMON_SCROLL_RIGHT: "दाईं ओर स्क्रॉल करें",
  COMMON_PREVIOUS: "पिछला",
  DFSWEB_DFS_REGISTRATION: "पंजीकरण",
  COMMON_NO_FILE_SELECTED: "कोई फ़ाइल चयनित नहीं",
  COMMON_PROCEED_WITH_OTP: "ओटीपी के साथ आगे बढ़ें",
  COMMON_DOWNLOAD_RECIEPT: "रसीद देखें और डाउनलोड करें",
  COMMON_CONGRATS: "बधाई हो !",
  COMMON_LOADING: "लोड हो रहा है, कृपया प्रतीक्षा करें...",
  COMMON_VIEW_ALL: "सभी को देखें",
  DFSWEB_GRM: "जीआरएम",
  DFSWEB_HELP: "सहायता",
  Help: "सहायता",
  "Help-details": "सहायता विवरण",
  DFSWEB_HOME: "होम",
  DFSWEB_HISTORY: "हिस्ट्री",
  DFSWEB_DASHBOARD: "डैशबोर्ड",
  Privacy_policy: "गोपनीयता नीति",
  Accessibility_statement: "सुगम्यता वक्तव्य",
  DFSWEB_MANDIPRICE: "बाजार भाव",
  DFSWEB_SCHEMES: "योजनाएँ",
  DFSWEB_FAQs: "अक्सर पूछे जाने वाले प्रश्न",
  DFSWEB_About: "हमारे बारे में",
  DFSWEB_About_Bihar: "हमारे बारे में",
  DFSWEB_Latest_Updates: "नवीनतम अपडेट",
  DFSWEB_Success_Volumes: "सफलता  विवरणी",
  // ── Rewamp appbar (DFS-3360) ──────────────────────────────────────────────
  REWAMP_NAV_ADVISORIES: "परामर्श",
  REWAMP_NAV_KNOWLEDGE: "ज्ञानकोष",
  REWAMP_NAV_TRACK_STATUS: "आवेदन की स्थिति ट्रैक करें",
  REWAMP_NAV_FARMER_REGISTRATION: "किसान पंजीकरण",
  REWAMP_NAV_LOGIN_REGISTER: "लॉगिन/पंजीकरण",
  REWAMP_COMING_SOON: "जल्द आ रहा है",
  REWAMP_COMING_SOON_BADGE: "जल्द आ रहा है",
  REWAMP_COMING_SOON_TITLE: "जल्द आ रहा है",
  REWAMP_COMING_SOON_MESSAGE: "यह सुविधा अभी विकसित की जा रही है और जल्द ही उपलब्ध होगी। उपलब्ध होते ही हम आपको सूचित करेंगे।",
  REWAMP_COMING_SOON_OKAY: "ठीक है",
  REWAMP_COMING_SOON_KNOWLEDGE_TITLE: "ज्ञान विकसित किया जा रहा है",
  REWAMP_NEWS_NO_UPDATES_TITLE: "कोई हालिया अपडेट नहीं",
  REWAMP_NEWS_EMPTY_DESC: "कृषि विभाग की ओर से अपडेट के लिए बने रहें।",
  REWAMP_NEWS_NEWS_DESC: "प्रकाशित होने पर समाचार यहाँ दिखाई देंगे। कृषि विभाग की ओर से अपडेट के लिए बने रहें।",
  REWAMP_NEWS_STAY_TUNED_DESC: "कृषि विभाग की ओर से\nअपडेट के लिए बने रहें।",
  REWAMP_NEWS_ARCHIVED_TITLE: "कोई संग्रहीत नहीं",
  "Load more": "और देखें",
  REWAMP_FAQ_NO_UPDATES_TITLE: "अभी कोई सामान्य प्रश्न नहीं",
  REWAMP_FAQ_EMPTY_DESC: "इस श्रेणी के लिए सामान्य प्रश्न जल्द ही जोड़े जाएंगे।",
  REWAMP_FAQ_PREPARING_DESC: "हमारी टीम सबसे सामान्य प्रश्नों के उत्तर तैयार कर रही है। ये जल्द ही यहाँ प्रकाशित किए जाएंगे।",
  REWAMP_KISAAN_HELPLINE: "किसान हेल्पलाइन",
  DFSWEB_SERVICEPROVIDER: "सेवा प्रदाता",
  DFSWEB_TRACK: "ट्रैक",
  ENTER_VALUE: "मान दर्ज करें",
  SELECT_VALUE: "मान चुनें",
  PROFILE_CREATE: "गैर-डीबीटी पंजीकरण",
  PROFILE_UPDATE: "डीबीटी प्रोफ़ाइल सिंक",
  PERSONAL_DETAILS: "व्यक्तिगत विवरण",
  Location_DETAILS: "स्थान विवरण",
  "Personal information": "व्यक्तिगत विवरण",
  "Personal Information": "व्यक्तिगत विवरण",
  "Location information": "स्थान विवरण",
  "Location Information": "स्थान विवरण",
  Bank_DETAILS: "बैंक जानकारी",
  DBT_PROFILE_CREATE: "डीबीटी पंजीकरण",
  SCHEME_APPLY: "योजना आवेदन",
  GRM_APPLY: "शिकायत पंजीकरण",
  DFSWEB_GRM9: "समस्या को रिपोर्ट और ट्रैक करें",
  "Edit-profile": "प्रोफ़ाइल संपादित करें",
  FETCH_PGR_ERROR: "शिकायत विवरण नहीं मिला, कृपया पुनः प्रयास करें",
  FILE_UPLOADING: "अपलोड हो रहा",
  FILE_UPLOAD_FAILED: "विफल",
  FILE_UPLOADED: "अपलोड",
  Grm: "शिकायत प्रबंधन",
  HISTORY_TICKET_NUMBER: "आवेदन/टिकट संख्या",
  INVALID_TICKET_ID: "शिकायत विवरण नहीं मिला, कृपया पुनः प्रयास करें",
  OTP_VALIDATION_FAILED: "अमान्य ओटीपी",
  TECH_COMMON_SUBMIT: "जमा करें",
  KnowMore: "और जानें",
  dialogContent:
    "आपको एक बाहरी वेबसाइट पर पुनर्निर्देशित किया जा रहा है। कृपया ध्यान दें कि बिहार कृषि वेबसाइट बाहरी वेबसाइटों की सामग्री और गोपनीयता नीतियों के लिए उत्तरदायी नहीं हो सकती।",
  Frequently_Asked_Questions: "सामान्य प्रश्न",
  govtOfBihar: "बिहार सरकार",
  lastUpdate: "अंतिम अद्यतन तिथि",
  BiharKrishiSupport: "बिहार कृषि सहायता",
  KisanCallCentre: "किसान कॉल सेंटर (टोल फ्री)",
  DBTPortal: "डीबीटी पोर्टल",
  BiharSeedCertificationAgency: "बिहार राज्य बीज एवं जैविक प्रमाणीकरण एजेंसी (बीएसएसओसीए)",
  BAVAS: "बिहार कृषि उत्पाद मूल्यवर्धन प्रणाली (बवास)",
  BWDS: "बिहार जलग्रहण विकास सोसायटी",
  DEPARTMENT_REVENUE_LAND_REFORM: "राजस्व एवं भूमि सुधार विभाग",
  PM_KISHAN: "प्रधानमंत्री किसान सम्मान निधि",
  BRBN: "बिहार राज्य बीज निगम",
  BAMETI: "बिहार कृषि प्रबंधन एवं प्रसार प्रशिक्षण संस्थान",
  DirectorateofHorticulture: "उद्यान निदेशालय",
  KisanCallCentrePortal: "किसान कॉल सेंटर पोर्टल",
  header: "संपर्क जानकारी",
  History: "इतिहास",
  ContactInformation: "संपर्क जानकारी",
  OtherImportantLinks: "अन्य महत्वपूर्ण लिंक",
  ImportantLinks: "महत्वपूर्ण लिंक",
  FOLLOW_US: "हमें फॉलो करें",
  krishiAppPlay:
    "सरकारी योजनाओं का लाभ उठाने के लिए बिहार कृषि ऐप डाउनलोड करें",
  Skip_to_main_content: "मुख्य सामग्री पर जाएं",
  "Switch to English": "अंग्रेज़ी में बदलें",
  "Switch to Hindi": "हिंदी में बदलें",
  // Rewamp accessibility options panel (Ctrl+F2 — RewampAccessibilityOptionsDialog).
  // Tile labels: the "\n" two-line keys are the visible labels; the space variants
  // (Dyslexia Friendly / Pause Animation) are the flattened aria-label keys.
  "Accessibility options": "सुगम्यता विकल्प",
  "Close accessibility options": "सुगम्यता विकल्प बंद करें",
  "Reset All Accessibility Options": "सभी सुगम्यता विकल्प रीसेट करें",
  "Reset All": "सभी रीसेट करें",
  "Created by": "निर्माता:",
  "Soon": "जल्द",
  "coming soon": "जल्द आ रहा है",
  "Bigger Text": "बड़ा टेक्स्ट",
  "Smaller Text": "छोटा टेक्स्ट",
  "Text Spacing": "टेक्स्ट अंतराल",
  "Line Height": "पंक्ति ऊंचाई",
  "Dyslexia\nFriendly": "डिस्लेक्सिया\nअनुकूल",
  "Dyslexia Friendly": "डिस्लेक्सिया अनुकूल",
  "ADHD Mode": "एडीएचडी मोड",
  "Saturation": "संतृप्ति",
  "Light-Dark": "लाइट-डार्क",
  "Invert Colors": "रंग उलटें",
  "Highlight Links": "लिंक हाइलाइट करें",
  "Text To Speech": "टेक्स्ट टू स्पीच",
  "Cursor": "कर्सर",
  "Pause\nAnimation": "एनिमेशन\nरोकें",
  "Pause Animation": "एनिमेशन रोकें",
  "Hide Images": "छवियां छिपाएं",
  "Open Accessibility Options": "एक्सेसिबिलिटी विकल्प खोलें",
  Screenreaderaccess: "स्क्रीन रीडर एक्सेस",
  ScreenReader: "स्क्रीन रीडर",
  Website: "वेबसाइट",
  FreeCommercial: "फ्री / कमर्शियल",
  schemeBanner: "सभी सक्रिय राज्य और केंद्र प्रायोजित योजनाएँ देखें।",
  Click: "क्लिक करें",
  imp_updates: "महत्वपूर्ण अपडेट",
  DepartofAgri: "कृषि विभाग",
  Cancel: "रद्द करें",
  OK: "ठीक है",
  EMPTY_DBT_ID: "कृपया डी.बी.टी दर्ज करें और फिर आगे बढ़ें।",
  INVALID_DBT_ID:
    "दर्ज किया गया डी.बी.टी अमान्य है। कृपया अपनी जानकारी जांचें और फिर से प्रयास करें।",
  EMPTY_MOBILE_NUMBER: "कृपया मोबाइल नंबर दर्ज करें और फिर आगे बढ़ें।",
  INVALID_MOBILE_NUMBER:
    "दर्ज किया गया मोबाइल नंबर अमान्य है। कृपया एक मान्य 10-अंकीय नंबर दर्ज करें और फिर से प्रयास करें।",
  FARMER_DOES_NOT_EXIST:
    "आपका मोबाइल नंबर बिहार कृषि पर पंजीकृत नहीं है। कृपया लाभ और सेवाओं के लिए पंजीकरण करें।",
  NON_DBT_USER: "लाभ प्राप्त करने के लिए कृपया डीबीटी के साथ पंजीकरण करें",
  INVALID_OTP: "अमान्य ओटीपी",
  INCORRECT_OTP: "अमान्य ओटीपी",
  IP_ADDRESS_ERROR:
    "आपका IP पता प्राप्त किया जा रहा है, कृपया प्रतीक्षा करें...",
  KeyContacts: "मुख्य संपर्क",
  LatestNews: "ताज़ा खबर",
  LearnMore: "और अधिक जानें",
  LogInToAccount: "अपने खाते में लॉग इन करें",
  NumberAboutOurSuccess:
    'संख्याएँ जो हमारी <span style="color: {{color}};">सफलता</span> के बारे में कहती हैं!',
  Success: "सफलता!",
  OurOfferings: "हमारी सेवाएँ",
  Photos: "फोटो",
  QuickAction: "त्वरित कार्रवाई",
  ReadMore: "और पढ़ें",
  ReadLess: "कम पढ़ें ",
  REPORT_A_ISSUE: "किसी समस्या की रिपोर्ट करें",
  scan_to_download: "बिहार कृषि मोबाइल ऐप डाउनलोड करने के लिए इसे स्कैन करें",
  Social: "सोशल मीडिया",
  TICKET_NUMBER: "टिकट नंबर",
  TRACK_ISSUE_STATUS: "समस्या की स्थिति को ट्रैक करें",
  TYPE_OF_REQUEST: "अनुरोध का प्रकार",
  Videos: "वीडियो",
  View_all_daq: "सभी सामान्य प्रश्न देखें",
  View: "देखें",
  ViewAllOfferings: "सभी पेशकशें देखें",
  ViewAllSchemes: "सभी योजनाएँ देखें",
  GotoRegistration: "पंजीकरण पर जाएं",
  CreateTicket: "टिकट बनाएं",
  ViewDetails: "विवरण देखें",
  Report: "रिपोर्ट करें",
  FILE_TYPE_ERROR: "फ़ाइल प्रकार समर्थित नहीं है",
  FILE_UPLOAD_FAILED_ERROR: "अपलोड असफल रहा। कृपया पुनः प्रयास करें!",
  UPLOAD_FILES: "फ़ाइलें अपलोड करें",
  Track: "ट्रैक करें",
  COMMON_HISTORY: "इतिहास",
  REJECTED: "अस्वीकृत",
  SCHEME_APPLICATION_GET_ERROR: "योजना आवेदन नहीं मिला",
  Mandi: "बाज़ार भाव",
  "Price-details": "मूल्य विवरण",
  MANDI_PRICE: "कीमत",
  MANDI_MARKET_PRICE: "बाज़ार मूल्य",
  COMMON_APPLY: "आवेदन करें",
  COMMODITY_PRICE_HEADER: "कीमत",
  MANDI_COMMODITY_PRICE_TREND: "मूल्य प्रवृत्ति",
  MANDI_PAST_PRICES_LABEL: "पिछली कीमतें",
  PRICE_QUINTOL: "क्विंटल",
  MANDI_PRICE_HEADER: "बाज़ार भाव",
  COMMON_DISTRICT: "ज़िला",
  COMMON_BLOCK: "ब्लॉक",
  COMMON_VILLAGE_PANCHAYAT: "ग्राम पंचायत",
  MANDI_MARKET: "बाज़ार",
  MANDI_COMMODITY_CROP: "फसल/वस्तु",
  COMMON_ID: "आईडी",
  COMMON_NAME: "नाम",
  Manager: "मैनेजर",
  COMMON_DELETE: "डिलीट करें",
  COMMON_DELETE_WARNING:
    "क्या आप सुनिश्चित रूप से इस आइटम को डिलीट करना चाहते हैं?",
  COMMON_DELETE_SELECTED_ITEMS_WARNING:
    "क्या आप वाकई चयनित आइटम को हटाना चाहते हैं?",
  COMMON_YES_DELETE: "हाँ, डिलीट करें",
  COMMON_YES: "हाँ",
  COMMON_NO: "नहीं",
  COMMON_CANCEL: "रद्द करें",
  COMMON_YES_CONTINUE: "हाँ, जारी रखें",
  COMMON_CONTINUE: "जारी रखें",
  DELETE_SUCCESSFUL: "रिकॉर्ड सफलतापूर्वक हटा दिया गया है",
  DELETE_MULTI_SUCCESSFUL: "रिकॉर्ड सफलतापूर्वक हटा दिए गए हैं",
  DFSWEB_DATA_REVIEW: "डेटा समीक्षा",
  DFSWEB_DATA_REVIEW_DESC: "यहां से डेटा प्रबंधित करें",
  "Data-cleanup": "डेटा समीक्षा",
  MANDI_FROM_DATE: "की तिथि से",
  MANDI_TO_DATE: "तारीख तक",
  COMMON_DATE: "तारीख",
  MANDI_COMMODITY: "फसल",
  MANDI_VARIETY: "विविधता",
  MANDI_MIN_PRICE: "न्यूनतम कीमत",
  MANDI_MAX_PRICE: "अधिकतम कीमत",
  MANDI_ERROR_LOADING_MARKET_DATA: "डेटा लोड करने में त्रुटि",
  MANDI_NO_MARKET_DATA: "कोई डेटा मौजूद नहीं",
  NoRecordFound: "कोई सुझाव नहीं मिला",
  MANDI_DATE_FILTER_ERROR: "कृपया चुनें",
  SELECT_Date: "तिथि चुनें",
  VERIFY_FARMER: "किसान विवरण सत्यापित करें",
  APPLICATION_FORM: "आवेदन पत्र",
  PREVIEW_SUBMIT: "पूर्वावलोकन और जमा करें",
  Categories: "श्रेणियाँ",
  SearchAssets: "कृषि संसाधन खोजें",
  QuickFilters: "क्विक फ़िल्टर्स",
  Filters: "फ़िल्टर्स",
  Privacypolicy: "गोपनीयता नीति/उपयोग की शर्तें पृष्ठ",
  SearchContact: "संपर्क खोजें",
  Search: "खोजें",
  contactPerson: "संपर्क व्यक्ति",
  cropName: "फसल का नाम: ",
  CROP_NAME: "फसल का नाम",
  Type: "प्रकार",
  Name: "नाम",
  CapacityDetails: "क्षमता विवरण",
  EstYear: "स्थापना वर्ष",
  MobileNo: "मोबाइल नं.",
  Established: "स्थापना",
  Address: "पता",
  ASSET_BANK_NAME: "बैंक का नाम",
  ASSET_BRANCH_NAME: "शाखा का नाम",
  ASSET_BRANCH_ADDRESS: "शाखा का पता",
  ASSET_IFSC_CODE: "आई.एफ.एस.सी कोड",
  ASSET_BANK_CODE: "बैंक कोड",
  ASSET_BRANCH_CODE: "शाखा कोड",
  ASSET_BRANCH_STATUS: "स्थिति",
  ASSET_ALL: "सभी",
  ASSET_SELECT_DISTRICT: "जिला चुनें",
  ASSET_SELECT_BLOCK: "ब्लॉक चुनें",
  ASSET_SELECT_BANK: "बैंक चुनें",
  ASSET_SELECT_BRANCH: "शाखा चुनें",
  ASSET_PICK_BLOCK_PROMPT: "जैविक एफ.पी.ओ देखने के लिए जिला और ब्लॉक चुनें",
  ASSET_PICK_DISTRICT_INDUSTRY_PROMPT: "इकाइयाँ देखने के लिए जिला चुनें",
  ASSET_JAIVIK_FPO_NAME: "एफ.पी.ओ का नाम",
  ASSET_MAJOR_CROPS: "प्रमुख फसलें",
  ASSET_INDUSTRY_UNIT_NAME: "इकाई का नाम",
  ASSET_INDUSTRY_STATUS: "स्थिति",
  ASSET_INDUSTRY_CAPACITY: "क्षमता",
  ASSET_INDUSTRY_CONTACT: "संपर्क नंबर",
  ASSET_INDUSTRY_PRODUCT: "उत्पाद",
  ASSET_INDUSTRY_PROJECT_COST: "परियोजना लागत",
  ASSET_INDUSTRY_ESTABLISH_YEAR: "स्थापना वर्ष",
  licenseNo: "लाइसेंस संख्या",
  currentBalance: "वर्तमान शेष",
  activities: "व्यावसायिक क्षेत्र",
  sourceText: "स्रोतः ",
  sourceWeather: "बिहार मौसम सेवा केंद्र",
  Assets_home_text:
    "कृषि संसाधन अनुभाग में आपका स्वागत है, यहां आप बिहार के सभी जिलों में मौजूद विभिन्न कृषि संस्थानों और संसाधनों की श्रेणीवार जानकारी आसानी से देख सकते हैं। यहाँ से आप राज्य के सभी जिलों में उपलब्ध कृषि संसाधनों की जानकारी एवं संपर्क विवरण प्राप्त कर सकते हैं, साथ ही इन-ऐप कॉल सुविधा के जरिए आप इस अनुभाग में दिए गए किसी भी संपर्क नंबर पर कॉल करके सम्बंधित व्यक्ति से तुरंत संपर्क भी कर सकते हैं।",
  farmerRegistration: {
    PERSONAL_DETAILS: "व्यक्तिगत जानकारी",
    DBT_ID: "डीबीटी आईडी",
    FARMER_NAME: "किसान का नाम",
    "FATHER/MOTHER/HUSBAND_NAME": "पिता/माता/पति का नाम",
    DATE_OF_BIRTH: "जन्म तिथि",
    AGE: "आयु",
    GENDER: "लिंग",
    MOBILE_NUMBER: "मोबाइल नम्बर",
    FARMER_TYPE: "किसान का प्रकार",
    CASTE_CATEGORY: "जाति का प्रकार",
    FARMER_CATEGORY: "कृषक श्रेणी",
    DISTRICT: "जिला",
    BLOCK: "ब्लॉक",
    VILLAGE_PANCHAYAT: "ग्राम पंचायत",
    VILLAGE: "ग्राम",
    PINCODE: "पिन कोड",
    RESEND_OTP: "ओटीपी पुनः भेजें",
    OTP: "ओटीपी",
    PLEASE_VERIFY: "कृपया सत्यापित करें",
    OTP_SENT_TO_MOBILE_NO_1: "हमने आपके पंजीकृत मोबाइल नंबर",
    OTP_SENT_TO_MOBILE_NO_2: "पर एक ओटीपी भेजा है।",
    RETRY1: "",
    RETRY2: "में पुनः कोशिश करें",
    VERIFY: "सत्यापित करें",
    DBT_SYNC: "डीबीटी सिंक",
    SUBMIT: "जमा करें",
    CHANGE_PHOTO: " फोटो बदलें",
    DIDNOT_RECIEVE: "प्राप्त नहीं हुआ?",
    FARMER_ALREADY_EXIST: "किसान पहले से ही बिहार कृषि में मौजूद है।",
    BANK_NAME: "बैंक का नाम",
    ACCOUNT_NUMBER: "खाता सं०",
    IFSC_CODE: "आई.एफ.एस.सी कोड",
    BANK_BRANCH_ADDRESS: "बैंक शाखा का पता",
    REGISTRATION_UPDATE_SUCCESSFUL:
      "आपका बिहार कृषि पंजीकरण सफलतापूर्वक अद्यतन  किया गया है।",
    REGISTRATION_CREATE_SUCCESSFUL:
      "बधाई हो! आपका बिहार कृषि पंजीकरण सफलतापूर्वक बना दिया गया है।",
    CONGRATULATIONS: "बधाई हो!",
    OWN: "रैयत",
    RENTED: "गैर - रैयत",
    MIXED: "रैयत + गैर - रैयत",
    SMALL: "लघु किसान (1-2 हेक्टेअर)",
    MEDIUM: "सीमांत किसान (1 हेक्टेअर से कम)",
    LARGE: "बृहत किसान (2 हेक्टेयर से अधिक)",
    MALE: "पुरुष",
    FEMALE: "महिला",
    OTHER: "अन्य",
    MINORITY: "अल्पसंख्यक",
    SC: "अनुसूचित जाति",
    ST: "अनुसूचित जनजाति",
    OBC: "अन्य पिछड़ा वर्ग",
    BACKWARD: "पिछड़ा वर्ग",
    GENERAL: "सामान्य",
    REQUIRED_FARMER_NAME: "कृपया किसान का नाम लिखें",
    REQUIRED_RELATIVE_NAME: "कृपया किसान के रिश्तेदार का नाम लिखें",
    REQUIRED_DOB: "कृपया जन्म तिथि लिखें",
    REQUIRED_AGE: "कृपया किसान की आयु लिखें",
    REQUIRED_GENDER: "कृपया किसान का लिंग चुनें",
    REQUIRED_MOBILE_NUMBER: "कृपया मोबाइल नंबर लिखें",
    MAXLENGTH_MOBILE_NUMBER: "मोबाइल नंबर 10 अंकों से अधिक नहीं होना चाहिए",
    MINLENGTH_MOBILE_NUMBER: "मोबाइल नंबर कम से कम 10 अंक का होना चाहिए",
    REQUIRED_FARMER_TYPE: "कृपया किसान का प्रकार चुनें",
    REQUIRED_CASTE_CATEGORY: "कृपया किसान की जाति श्रेणी चुनें",
    REQUIRED_FARMER_CATEGORY: "कृपया किसान की श्रेणी चुनें",
    REQUIRED_DISTRICT: "कृपया जिला चुनें",
    REQUIRED_BLOCK: "कृपया प्रखंड चुनें",
    REQUIRED_PANCHAYAT: "कृपया पंचायत चुनें",
    REQUIRED_VILLAGE: "कृपया गाँव चुनें",
    PINCODE_PATTERN: "कृपया 6 अंकों का वैध पिनकोड दर्ज करें",
    NOT_AVAILABLE: "उपलब्ध नहीं है ",
    MOBILE_MAXLENGTH: "मोबाइल नंबर 10 अंकों से अधिक नहीं होना चाहिए",
    MOBILE_MINLENGTH: "मोबाइल नंबर कम से कम 10 अंक का होना चाहिए",
    FARMER_NAME_MINLENGTH: "किसान का नाम कम से कम 2 वर्ण होना चाहिए",
    FARMER_RELATIVE_NAME_MAXLENGTH:
      "किसान के रिश्तेदार का नाम 100 वर्णों से अधिक नहीं होना चाहिए",
    PINCODE_REQUIRED: "कृपया पिनकोड दर्ज करें",
    UNEXPECTED_ERROR: "एक अप्रत्याशित त्रुटि हुई है।",
    UPDATE_NOT_SUPPORTED:
      "सिंक नहीं हो सका: मोबाइल नंबर बदल गया है। कृपया सहायता से संपर्क करें।",
    PHOTO_UPLOAD_SUCCESS: "फ़ोटो सफलतापूर्वक अपलोड हो गया है।",
    EG_FILESTORE_INVALID_INPUT:
      "अवैध फ़ाइल प्रकार। कृपया अपलोड करें: [JPG, JPEG, PNG]।",
    OTP_SEND_FAILED: "ओटीपी भेजने में विफल। कृपया फिर से प्रयास करें।",
    OTP_RESEND_FAILED: "ओटीपी पुनः भेजने में विफल। कृपया फिर से प्रयास करें।",
    INVALID_DBT_ID:
      "दिया गया डी.बी.टी आई.डी अमान्य है। कृपया अपने इनपुट की जाँच करें और फिर से प्रयास करें।",
    RE_LOGIN: "पुनः लॉगिन करें",
    RE_LOGIN_MESSAGE:
      "आपका मोबाइल नंबर आपके डीबीटी खाते के नंबर के साथ अपडेट कर दिया गया है, कृपया लॉगआउट करें",
    RE_LOGIN_HEADER:
      "क्षमा करें, डीबीटी आई. डी. और मोबाइल नंबर मेल नहीं खाते",
  },
  weather: {
    Sun: "रविवार",
    Mon: "सोमवार",
    Tue: "मंगलवार",
    Wed: "बुधवार",
    Thu: "गुरुवार",
    Thur: "गुरुवार",
    Fri: "शुक्रवार",
    Sat: "शनिवार",
  },
  WindDirection: "हवा की दिशा",
  WindSpeed: "हवा की गति",
  Rain: "बारिश",
  Max_MinTemp: "अधिकतम/न्यूनतम तापमान",
  Max_MinTemperature: "अधिकतम / न्यूनतम तापमान",
  Date: "तारीख",
  day_forcast: "अगले 3 दिनों का पूर्वानुमान",
  TodayWeather: "आज का मौसम",
  N: "उ.",
  E: "पू.",
  S: "द.",
  W: "प.",
  NE: "उ.पू.",
  SE: "द.पू.",
  SW: "द.प.",
  NW: "उ.प.",
  North: "उत्तर",
  East: "पूर्व",
  South: "दक्षिण",
  West: "पश्चिम",
  "North East": "उत्तर-पूर्व",
  "South East": "दक्षिण-पूर्व",
  "South West": "दक्षिण-पश्चिम",
  "North West": "उत्तर-पश्चिम",
  mm: "मिमी",
  "km/h": "किमी/घंटा",
  Weatherdata: "मौसम",
  Sun: "रविवार",
  Mon: "सोमवार",
  Tue: "मंगलवार",
  Wed: "बुधवार",
  Thur: "गुरुवार",
  Fri: "शुक्रवार",
  Sat: "शनिवार",
  get_direction: "दिशा प्राप्त करें",
  directions: "दिशा प्राप्त करें",
  Bihar: "बिहार",
  Q: "प्र",
  A: "उ",
  Acc: "अ",
  COMMON_USERNAME: "उपयोगकर्ता नाम",
  COMMON_ENTER_PASSWORD: "",
  COMMON_PASSWORD: "पासवर्ड",
  notEligible: "माफ करें, यह स्थान उपलब्ध नहीं है। कृपया एक अलग स्थान चुनें।",
  notAvaliable:
    "माफ करें! स्थान विवरण मेल नहीं खाता। कृपया सहायता के लिए संपर्क करें।",
  Complaintdetails: "शिकायत विवरण",
  Sitemap: "साइट मैप",
  landingPage: "लैंडिंग पृष्ठ",
  Footer: "फुटर",
  Storage: "स्टोरेज",
  Office: "कृषि कार्यालय",
  Education: "कृषि संस्थान",
  Bazaar: "बाजार",
  Industries: "उद्योग",
  OtherAssets: "अन्य संसधान",
  Cold_Storage: "कोल्ड स्टोरेज",
  Agri_Godowns: "कृषि गोदाम",
  Panchayat_Office: "पंचायत कार्यालय",
  "e-Kisan_Bhavan": "ई-किसान भवन",
  DAO_Office: "डीएओ कार्यालय",
  KVK: "कृषि विज्ञान केंद्र",
  Agriculture_College: "कृषि महाविद्यालय",
  Pashu_Bazaar: "पशु बाजार",
  Market_Nodes: "बाजार समिति",
  Agri_Input_Shops: "कृषि-इनपुट उपादान",
  Agriculture_Farms: "कृषि फार्म",
  Rice_Mill: "राइस मिल",
  Custom_Hiring_Center: "कस्टम हायरिंग सेंटर",
  "Fpo-Farmers_Producers_Services": "किसान उत्पादक संगठन",
  Commodity_Price: "फसल कीमत",
  Contact_US: "हमसे संपर्क करें",
  TrackScheme: "योजना ट्रैक",
  FARMER_PASSBOOK: "किसान पासबुक",
  "Farmer-passbook": "किसान पासबुक",
  "Agent-access": "सत्यापन",
  PROCESSING_PASSBOOK_INFO:
    "आपका पासबुक लाया जा रहा है। इसमें कुछ समय लग सकता है, कृपया थोड़ी देर बाद पुनः जांचें।",
  NO_PASSBOOK_RECORDS: "कोई पासबुक रिकॉर्ड नहीं मिला।",
  Choose_Year: "वर्ष चुनें",
  SL_NO: "क्रमांक",
  Sub_Scheme_Name: "उप योजना का नाम",
  Application_Date: "आवेदन तिथि",
  Subsidy_Type: "सब्सिडी का प्रकार",
  Settlement_Date: "निपटान तिथि",
  Benefit_Allocation: "लाभ आवंटन",
  Download_PDF: "पीडीएफ डाउनलोड करें",
  PDF: "पीडीएफ",
  help: {
    SpeaktoDOAOfficials:
      "कृषि विभाग के अधिकारियों से बात करें या कॉल सेंटर से जुड़ें",
    CallCenters: "कॉल सेंटर्स",
    DBTIDRelatedServices: "डीबीटी सम्बंधित सेवाएं",
    OtherRelevantServices: "अन्य महत्वपूर्ण सेवाएं",
    MandiAnalysts: "मंडी एनालिस्ट",
    CertificationInspectors: "प्रमाणन निरीक्षक (बीज/जैविक)",
    SAO: "स्थानीय एसएओ अधिकारियों से सम्पर्क करे",
    AgricultureCoordinator: "कृषि समन्वयक",
    KisanSalahkar: "किसान सलाहकार",
    NominatedACforMarketNodes: "मार्केट नोड्स के नामित कृषि समन्वयक",
    AssistantDirectorofPlantProtection: "पौधा संरक्षण-सहायक निदेशक",
    EthanolIndustries: "इथेनॉल उद्योग",
    JaivikFPOs: "जैविक एफपीओ",
    ReportTechnicalissue: "तकनीकी समस्या की रिपोर्ट करें",
    Foodprocessing: "खाद्य प्रसंस्करण",
    availableTimings: "उपलब्ध समय",
    availableDays: "उपलब्ध दिन",
    Capacity: "क्षमता",
    Status: "स्थिति",
    status: "स्थिति",
    address: "पता",
    capacity: "क्षमता",
    establishYear: "स्थापना वर्ष",
    productName: "प्रोडक्ट का नाम",
    majorCrops: "प्रमुख फसलें",
    bac: "मार्केट नोड्स के नामित कृषि समन्वयक",
    commoditiesTraded: "कमोडिटीज ट्रेडेड",
    oci: "जैविक प्रमाणन निरीक्षक",
    si: "बीज प्रमाणन निरीक्षक",
    si1: "बीज प्रमाणन निरीक्षक- 1",
    si2: "बीज प्रमाणन निरीक्षक- 2",
    si3: "बीज प्रमाणन निरीक्षक- 3",
    dao: "DAO",
    dho: "DHO",
    ade: "ADE",
    adc: "ADC",
    noDataFound:
      "कोई डेटा नहीं मिला। कृपया बाद में फिर से जांचें या अपनी खोज को परिष्कृत करें।",
  },
  //soil health
  Soil_health: "मृदा का स्वास्थ्य",
  soil_health_Detail: "मृदा के स्वास्थ्य का विवरण",
  "Soil-health-details": "मृदा के स्वास्थ्य का विवरण",
  soil_health_labs: "मृदा परीक्षण प्रयोगशालाएँ",
  soil_health_card: "मृदा स्वास्थ्य कार्ड",
  agriAdvisory: "कृषि सलाह",
  filterByDistrict: "जिले के अनुसार फ़िल्टर करें",
  Distance: "दूरी",
  Download: "डाउनलोड",
  approx: "लगभग",
  KM: "किमी",
  Email: "ईमेल",
  phoneNumberCopied: "फ़ोन नंबर कॉपी किया गया",
  bankDetailsCopied: "बैंक विवरण कॉपी किया गया",
  WhatsApp: "व्हाट्सएप",
  copyBankDetails: "कॉपी करें",
  sortBy: "क्रमबद्ध करें",
  sortNearest: "निकटतम",
  sortNameAsc: "नाम (A-Z)",
  FinancialYears: "वित्तीय वर्ष",
  TestGrid: "परीक्षण ग्रिड",
  KhataKasara: "खाता/खसरा",
  selectAtLeast1NPK:
    "कृपया नाइट्रोजन, फास्फेट या पोटाश में से कम से कम एक चयन करें।",
  selectAtLeast1Crop: "कृपया कम से कम एक फसल और उसके संबंधित उपज का चयन करें।",
  GenerateReport: "रिपोर्ट उत्पन्न करें",
  Potash: "पोटाश",
  Phosphate: "फास्फेट",
  Nitrogen: "नाइट्रोजन",
  Yield: "उपज",
  Crop: "फसल",
  selectCrop: "कृपया फसलें और लक्ष्य उपज चुनें।",
  LandSize: "भूमि का आकार",
  Check_more_crop: "अधिक फसल देखें",
  selectNPK: "कृपया उर्वरक का चयन करें, जिसे आप उपयोग करना चाहते हैं।",
  NPKGroup: "N.P.K समूह",
  name: "नाम",
  SoilHealthId: "मृदा स्वास्थ्य कार्ड आईडी:",
  Validity: "वैधता:",
  DataAnalysis: "डेटा विश्लेषण",
  Resource: "संसाधन",
  testDate: "परीक्षण तिथि:",
  BasedInput: "डेटा विश्लेषण: डेटा इनपुट्स के आधार पर प्रदर्शित किया गया।:",
  Share: "साझा करें",
  whereShare: "कृपया चयन करें कि आप मृदा का विवरण कहाँ साझा करना चाहते हैं।",
  "Farmer-details": "किसान विवरण सत्यापित करें",
  selectAnotherYear: "कृपया रिकॉर्ड देखने के लिए कोई अन्य वित्तीय वर्ष चुनें।",
  SessionTimeout: "किसान सत्र समाप्त हो गया है।",
  selectArea: "कृपया क्षेत्र और इकाई चुनें।",
  whatsAppSuccess:
    "व्हाट्सएप संदेश सफलतापूर्वक भेजा गया है। कृपया 2-3 मिनट बाद जांचें।",
  whatsAppFailure:
    "व्हाट्सएप संदेश भेजने में कोई समस्या आई है। कृपया कुछ समय बाद पुनः प्रयास करें।",
  farmersDashboard: "किसान पंजीकरण",
  schemesApplications: "योजनाओं के लिए आवेदन",
  grmDashboard: "जीआरएम",
  COMMON_AMOUNT: "राशि",
  Radio: "रेडियो",
  Bihar_Krishi_Radio: "बिहार कृषी रेडियो में ट्यून करें",
  Now_playing_Radio: "अब बिहार कृषि रेडियो चल रहा है",
  Play: "प्ले",
  Pause: "पॉज़",
  Stop: "रोकें",
  Mute: "म्यूट",
  Unmute: "अनम्यूट",
  Volume: "वॉल्यूम",
  Reviews: "समीक्षाएँ",
  Percentage: "प्रतिशत",
  Star: "स्टार",
  Stars: "स्टार्स",
  Component: "अवयव",
  Group_description: "समूह का विवरण",
  "Group/Company_Registration_No": "पंजीयन संख्या",
  "Group/Company_Registration_Date": "पंजीयन तिथि",
  "Group/Company_Name": " ग्रुप/कंपनी का नाम",
  "Applied_Unit_(125_Sq.m._Per_Unit)": "आवेदित इकाई (125 वर्गमीटर प्रति इकाई)",
  "Acreage_(in_Acres)": "कूल रकवा(एकड़ में)",
  "Applied_acreage_(in_acres)": "आवेदित रकवा (एकड़ में)",
  selectAValue: "एक विकल्प चुनें",
  Farmer: "किसान",
  Others: "अन्य",
  COMMON_MOBILE: "मोबाइल नंबर दर्ज करें",
  // Figma 91-27308 — farmer login mobile step
  FARMER_LOGIN_MOBILE_LABEL: "मोबाइल नंबर",
  FARMER_LOGIN_MOBILE_PLACEHOLDER: "मोबाइल नंबर दर्ज करें।",
  GENERATE_OTP: "ओटीपी जनरेट करें",
  // Figma 521-6842 — other (employee) login step
  OTHER_LOGIN_USERNAME_PLACEHOLDER: "उपयोगकर्ता नाम दर्ज करें",
  OTHER_LOGIN_PASSWORD_PLACEHOLDER: "पासवर्ड दर्ज करें",
  COMMON_USERNAME_REQUIRED: "कृपया उपयोगकर्ता नाम दर्ज करें",
  COMMON_PASSWORD_REQUIRED: "कृपया पासवर्ड दर्ज करें",
  OTHER_LOGIN_INVALID_CREDENTIALS: "गलत उपयोगकर्ता नाम या पासवर्ड",
  COMMON_SERVER_ERROR: "कुछ गलत हो गया। कृपया पुनः प्रयास करें।",
  COMMON_LOGIN_TYPE: "लॉगिन प्रकार",
  dbt_dfs_registered_phone: "डीबीटी या डीएफएस - पंजीकृत मोबाइल नंबर",
  additional_information: "अतिरिक्त जानकारी",
  are_you_physically_disabled: "क्या आप शारीरिक रूप से दिव्यांग हैं?",
  // Placeholder pending BLOCKERS.md B6 (legal/product consent copy) — machine
  // translation of the English string, not yet reviewed. See
  // notes/rewamp/onboarding/BLOCKERS.md.
  FARMER_LOGIN_CONSENT:
    "मैं सहमति देता/देती हूं कि बिहार कृषि मेरी व्यक्तिगत जानकारी का उपयोग सरकारी योजनाओं, सलाह, नीतियों, बीमा और संबंधित सेवाओं के लिए करे। मेरा डेटा वैधानिक कानूनों के अनुसार सुरक्षित रखा जाएगा।",
  // Placeholder — machine translation, not yet reviewed. Figma only
  // specified the English copy for 91-29540/91-29711.
  ONBOARDING_ACCOUNT_CREATED_TITLE: "बिहार कृषि में आपका स्वागत है!",
  ONBOARDING_ACCOUNT_CREATED_SUBTITLE:
    "आपका पंजीकरण सफलतापूर्वक पूरा हो गया है। बिहार कृषि समुदाय का हिस्सा बनने पर हम आपका स्वागत करते हैं।",
  ONBOARDING_ACCOUNT_CREATED_CTA: "जारी रखें",
  ONBOARDING_CREATING_PROFILE_TITLE: "आपका प्रोफ़ाइल बनाया जा रहा है",
  ONBOARDING_CREATING_PROFILE_SUBTITLE:
    "इसमें कुछ क्षण लग सकते हैं। कृपया प्रतीक्षा करें जब तक हम आपके लिए सब कुछ तैयार करते हैं।",
  ONBOARDING_CREATING_PROFILE_FAILED_TITLE: "आपका प्रोफ़ाइल नहीं बनाया जा सका",
  ONBOARDING_CREATING_PROFILE_FAILED_SUBTITLE:
    "डीबीटी रिकॉर्ड से किसान प्रोफ़ाइल सेट नहीं हो सका। कृपया पुनः प्रयास करें या साइन इन पर लौटने के लिए रद्द करें।",
  COMMON_RETRY: "पुनः प्रयास करें",
  // Placeholder — machine translation, not yet reviewed.
  ONBOARDING_NON_DBT_BANNER:
    "डीबीटी के तहत पंजीकृत नहीं हैं?  आप नीचे दिए गए विवरण भरकर भी शामिल हो सकते हैं।",
  ONBOARDING_NAME_PLACEHOLDER: "अपना नाम दर्ज करें",
  ONBOARDING_DISTRICT_PLACEHOLDER: "जिला चुनें",
  ONBOARDING_BLOCK_PLACEHOLDER: "ब्लॉक चुनें",
  ONBOARDING_PANCHAYAT_PLACEHOLDER: "पंचायत चुनें",
  ONBOARDING_JEEVIKA_MEMBER: "क्या आप जीविका सदस्य हैं?",
  ONBOARDING_JEEVIKA_ID: "जीविका आईडी",
  ONBOARDING_JEEVIKA_ID_PLACEHOLDER: "जीविका आईडी दर्ज करें",
  ONBOARDING_SHG_NAME: "एसएचजी का नाम",
  ONBOARDING_SHG_PLACEHOLDER: "एसएचजी का नाम दर्ज करें",
  ONBOARDING_VO_NAME: "वीओ का नाम",
  ONBOARDING_VO_PLACEHOLDER: "वीओ का नाम दर्ज करें",
  ONBOARDING_CLF_NAME: "सीएलएफ का नाम",
  ONBOARDING_CLF_PLACEHOLDER: "सीएलएफ का नाम दर्ज करें",
  ONBOARDING_OTP_VERIFICATION_TITLE: "ओटीपी सत्यापन",
  ONBOARDING_ACCOUNT_VERIFICATION_TITLE: "अपना खाता सत्यापित करें",
  ONBOARDING_ACCOUNT_VERIFICATION_BREADCRUMB: "खाता सत्यापन",
  ONBOARDING_OTP_SENT_PREFIX: "आपके मोबाइल नंबर पर भेजा गया 6 अंकों का ओटीपी दर्ज करें ",
  ONBOARDING_OTP_ENTER_LABEL: "ओटीपी दर्ज करें",
  ONBOARDING_OTP_EXPIRED: "ओटीपी समाप्त हो गया है। कृपया नया ओटीपी अनुरोध करें।",
  ONBOARDING_OTP_INCORRECT: "अमान्य ओटीपी",
  ONBOARDING_OTP_RETRY_IN: "प्राप्त नहीं हुआ? {{time}}s में पुनः प्रयास करें",
  COMMON_OTP_REQUIRED: "कृपया ओटीपी दर्ज करें।",
  COMMON_FIELD_REQUIRED: "कृपया यह फ़ील्ड भरें",
  ONBOARDING_SIGNIN_DBT: "डीबीटी",
  ONBOARDING_SIGNIN_NON_DBT: "गैर-डीबीटी",
  ONBOARDING_FIELD_NAME_REQUIRED: "कृपया अपना नाम दर्ज करें",
  ONBOARDING_FIELD_DISTRICT_REQUIRED: "कृपया जिला चुनें",
  ONBOARDING_FIELD_BLOCK_REQUIRED: "कृपया ब्लॉक चुनें",
  ONBOARDING_FIELD_PANCHAYAT_REQUIRED: "कृपया पंचायत चुनें",
  ONBOARDING_FIELD_GENDER_REQUIRED: "कृपया लिंग चुनें",
  ONBOARDING_FIELD_JEEVIKA_REQUIRED: "कृपया जीविका सदस्यता चुनें",
  ONBOARDING_FIELD_SHG_REQUIRED: "कृपया एसएचजी का नाम दर्ज करें",
  ONBOARDING_FIELD_VO_REQUIRED: "कृपया वीओ का नाम दर्ज करें",
  ONBOARDING_FIELD_CLF_REQUIRED: "कृपया सीएलएफ का नाम दर्ज करें",
  ONBOARDING_LEAVE_REGISTRATION_WARNING:
    "इस सुविधा तक पहुँचने के लिए कृपया अपना पंजीकरण पूरा करें।",
  ONBOARDING_RECOVER_TITLE: "अपना डीबीटी आई.डी. पुनः प्राप्त करें",
  ONBOARDING_RECOVER_SEND_OTP: "ओटीपी भेजें",
  ONBOARDING_RECOVER_MOBILE_LABEL: "मोबाइल नंबर",
  ONBOARDING_RECOVER_MOBILE_HINT: "मोबाइल नंबर दर्ज करें",
  ONBOARDING_RECOVER_MOBILE_NOT_REGISTERED:
    "यह मोबाइल नंबर डीबीटी के साथ पंजीकृत नहीं है।",
  ONBOARDING_RECOVER_NOTE:
    "यदि यह नंबर आपकी डीबीटी आई.डी. के साथ पंजीकृत है, तो इस पर 6-अंकीय ओटीपी भेजा जाएगा।",
  ONBOARDING_RECOVER_CONTINUE: "जारी रखें",
  ONBOARDING_RECOVER_CAPTCHA_LOADING: "सत्यापन लोड हो रहा है...",
  ONBOARDING_RECOVER_CAPTCHA_LOAD_FAILED:
    "सत्यापन लोड नहीं हो सका। कृपया पुनः प्रयास करें।",
  ONBOARDING_RECOVER_CAPTCHA_TITLE: "सुरक्षा सत्यापन",
  ONBOARDING_RECOVER_CAPTCHA_SUBTITLE:
    "आपके मोबाइल नंबर पर ओटीपी भेजने से पहले कृपया पुष्टि करें कि आप बॉट नहीं हैं।",
  ONBOARDING_RECOVER_CAPTCHA_VERIFY_CTA: "सत्यापित करें",
  ONBOARDING_RECOVER_CAPTCHA_VERIFYING: "सत्यापन हो रहा है…",
  ONBOARDING_RECOVER_CAPTCHA_VERIFYING_HINT: "इसमें कुछ सेकंड लग सकते हैं। कृपया प्रतीक्षा करें।",
  ONBOARDING_RECOVER_CAPTCHA_VERIFIED: "सत्यापन पूर्ण",
  ONBOARDING_RECOVER_CAPTCHA_VERIFIED_HINT:
    "अब आप अपने पंजीकृत मोबाइल नंबर पर ओटीपी भेज सकते हैं।",
  ONBOARDING_RECOVER_CAPTCHA_VERIFY_FAILED: "सत्यापन विफल। कृपया पुनः प्रयास करें।",
  ONBOARDING_RECOVER_CAPTCHA_EXPIRED: "कृपया पुष्टि करें कि आप रोबोट नहीं हैं",
  ONBOARDING_RECOVER_OTP_TITLE: "डीबीटी आई.डी. हेतु मोबाइल सत्यापन",
  ONBOARDING_DBT_ID_OTP_TITLE: "ओटीपी से डीबीटी आई.डी. सत्यापन",
  ONBOARDING_RECOVER_OTP_SUBTITLE: "अपने मोबाइल नंबर पर भेजा गया 6 अंकों का ओटीपी दर्ज करें",
  ONBOARDING_RECOVER_RESULT_TITLE: "डीबीटी आई.डी. पुनर्प्राप्ति आवेदन",
  ONBOARDING_RECOVER_RESULT_ALERT:
    "प्रिय {{name}}, आपका किसान पंजीकरण संख्या (DBT) सफलतापूर्वक प्राप्त कर लिया गया है। आपका पंजीकरण संख्या {{dbtId}} है। कृपया इसे सुरक्षित रखें, क्योंकि सब्सिडी का लाभ प्राप्त करने के लिए इसकी आवश्यकता होगी।",
  ONBOARDING_RECOVER_CONTINUE_LOGIN: "जारी रखें",
  ONBOARDING_RECOVER_DETAIL_DBT_ID: "डीबीटी आई.डी.",
  ONBOARDING_RECOVER_DETAIL_NAME: "नाम",
  ONBOARDING_RECOVER_DETAIL_MOBILE: "मोबाइल नंबर",
  ONBOARDING_RECOVER_DETAIL_DOB: "जन्म तिथि",
  ONBOARDING_RECOVER_DETAIL_DISTRICT: "जिला",
  ONBOARDING_RECOVER_DETAIL_PANCHAYAT: "पंचायत",
  ONBOARDING_RECOVER_DETAIL_FATHER_OR_HUSBAND: "पिता/पति का नाम",
  ONBOARDING_RECOVER_DETAIL_GENDER: "लिंग",
  ONBOARDING_RECOVER_DETAIL_FARMER_TYPE: "किसान प्रकार",
  ONBOARDING_RECOVER_DETAIL_BLOCK: "प्रखंड",
  ONBOARDING_RECOVER_DETAIL_VILLAGE: "गाँव",
  ONBOARDING_RECOVER_COPY_LABEL: "डीबीटी आई.डी. कॉपी करें",
  ONBOARDING_RECOVER_COPIED: "क्लिपबोर्ड पर कॉपी किया गया",
  ONBOARDING_RECOVER_DOWNLOAD: "डाउनलोड करें",
  otp_sent_message_1: "हमने आपके पंजीकृत मोबाइल नंबर {{maskedMobile}}",
  otp_sent_message_2: " पर एक ओटीपी भेजा है।",
  COMMON_MOBILE_INVALID: "यह नंबर पंजीकृत नहीं है",
  COMMON_MOBILE_RATE_LIMIT: "रेट लिमिट पूरी हो गई है, कृपया कुछ समय बाद पुनः प्रयास करें।",
  All_Schemes: "सभी योजनाएँ",
  Applied_Schemes: "आवेदन की गई योजनाएँ",
  Recommended_Schemes: "अनुशंसित योजनाएँ",
  remarks: "टिप्पणी",
  Refresh: "रिफ्रेश",
  Close: "बंद करें",
  requiredRegistrationGRM:
    "कृषि विभाग की योजनाओं में आवेदन करने के लिए डीबीटी पोर्टल पर पंजीकरण की आवश्यकता है। आगे बढ़ने के लिए डीबीटी पोर्टल पर पंजीकरण करें।",
  nonDbtNoticeGrievance:
    "कृषि विभाग में शिकायत दर्ज करने के लिए डीबीटी से जुड़ी प्रोफ़ाइल आवश्यक है। जारी रखने के लिए कृपया अपनी प्रोफ़ाइल में अपना डीबीटी आईडी अपडेट करें।",
  nonDbtNoticeScheme:
    "कृषि विभाग की योजनाओं में आवेदन करने के लिए डीबीटी से जुड़ी प्रोफ़ाइल आवश्यक है। जारी रखने के लिए कृपया अपनी प्रोफ़ाइल में अपना डीबीटी आईडी अपडेट करें।",
  nonDbtNoticeCta: "प्रोफ़ाइल अपडेट करें",
  soilNoTargetsNotice:
    "आपके प्रखंड में वर्तमान सत्र वर्ष के लिए लक्ष्य नहीं है, धन्यवाद |",
  Date_of_Application: "आवेदन की तिथि",
  APPLICATION_STATUS: "आवेदन की स्थिति",
  Applied: "आवेदन किया",
  address: "पता",
  COMMON_MOBILE_REQUIRED: "कृपया मोबाइल नंबर दर्ज करें",
  COMMON_MOBILE_INVALID_LENGTH: "मोबाइल नंबर की लंबाई 10 अंकों की होनी चाहिए",
  MOBILE_NUM_CHANGE_1: `कृपया ध्यान दें, आपके द्वारा दर्ज की गई डीबीटी आईडी किसी अन्य मोबाइल नंबर {{maskedMobileNumber}} से जुड़ी हुई है। यदि यह आपका मोबाइल नंबर है तो कृपया आगे बढ़ने के लिए पूरा मोबाइल नंबर दर्ज करें। कृपया ध्यान दें कि इस मोबाइल नंबर से जुड़े प्रोफ़ाइल विवरण को इस प्रोफ़ाइल पर मैप किया जाएगा।`,
  MOBILE_NUM_CHANGE_2: `यदि आप निश्चित हैं, तो कृपया "आगे बढ़ें" बटन पर क्लिक करें अन्यथा वापस जाने के लिए "रद्द करें" बटन पर क्लिक करें।`,
  FETCHED_DATA: "डेटा सफलतापूर्वक प्राप्त किया गया",
  MOBILE_MISMATCH: "मोबाइल नंबर मेल नहीं खाते हैं",
  MOBILE_ALREADY_REGISTERED:
    "मोबाइल नंबर पहले से ही पंजीकृत है। कृपया इस मोबाइल नंबर से लॉग इन करें।",
  WEATHER: "मौसम",
  cropSelect: "फसल चुनें",
  yieldSelect: "उपज चुनें",
  AADHAAR_NAME: "आधार पर नाम",
  selfRegistration: {
    haveDBT: "क्या आपके पास डीबीटी आई.डी. है?",
    registerDBT: "क्या आप डीबीटी में पंजीकरण कराना चाहते हैं?",
    dbtLinkHelper:
      "डीबीटी पोर्टल में रजिस्ट्रेशन हेतु नीचे दिये गये लिंक पर क्लिक करें",
    dbtDetails: "डीबीटी विवरण",
    fetchData: "डीबीटी डेटा प्राप्त करें",
    fetchPermission:
      "क्या आप डीबीटी पोर्टल से विवरण प्राप्त करना चाहेंगे?",
    dbtInputLabel: "किसान डीबीटी रजिस्ट्रेशन नंबर (13 अंक)",
    continue: "आगे बढ़ें",
    mobileInputLabel: "मोबाइल नंबर",
    mobileInputHelper:
      "साइन अप के लिए डीबीटी पंजीकृत मोबाइल नंबर {{maskedMobile}} का उपयोग करें।",
    back: "बाहर निकलें",
    notEligible:
      "माफ करें! स्थान विवरण मेल नहीं खाता। कृपया सहायता के लिए संपर्क करें।",
    DBT_ERROR:
      "सर्वर से डीबीटी विवरण प्राप्त करते समय त्रुटि, कृपया कुछ समय बाद पुनः प्रयास करें!",
  },
  Farmer_Registration: "किसान-पंजीकरण",
  Recover_DBT_ID: "डीबीटी आईडी पुनः प्राप्त करें",
  kg: "किग्रा",
  BACK_TO_LOGIN: "लॉगिन पर वापस जाएं",
  OTHER_LOGIN: "अन्य लॉग इन",
  FARMER_LOGIN: "किसान लॉग इन",
  DOWNLOAD_APP: "ऐप डाउनलोड करें",
  HORTI_MODULE_TITLE: "बागवानी",
  HORTI_ENQUIRY_HISTORY: "पूछताछ इतिहास",
  "Select Service": "सेवा चुनें",
  GOOGLE_PLAY: "गूगल प्ले",
  BANNER_DBT_ID_LABEL: "डीबीटी आईडी पंजीकरण — सुरक्षित, आसान। आज ही आवेदन करें।",
  BANNER_BIGHAAT_LABEL: "BigHaat — सभी कृषि उत्पाद ऑनलाइन खरीदें।",
  BANNER_APP_DOWNLOAD_LABEL: "बिहार कृषि ऐप को Google Play से डाउनलोड करें।",

  GA4_AVERAGE_SESSION_DURATION: "औसत सत्र अवधि",
  GA4_DAILY_ACTIVE_USERS: "दैनिक सक्रिय उपयोगकर्ता",
  COMMON_NO_DATA: "कोई डेटा नहीं",
  SOMETHING_WENT_WRONG: "कुछ गलत हो गया। कृपया पुनः प्रयास करें।",
  MIDH_DUPLICATE_CROP_EXCEPTION: "किसान की इस फ़सल के लिए पहले से ही एक आवेदन प्रक्रिया में है।",
  DUPLICATE_CROP_EXCEPTION: "किसान की इस फ़सल के लिए पहले से ही एक आवेदन प्रक्रिया में है।",
  MAX_FILES_INFO: "अधिकतम फ़ाइलें अपलोड हो चुकी हैं",
  FOLDER_UPLOAD_NOT_SUPPORTED: "फ़ोल्डर अपलोड नहीं किए जा सकते। कृपया एक फ़ाइल चुनें।",
  DOWNLOAD_DOCUMENT: "दस्तावेज़ डाउनलोड करें",
  PhotoDoc: "फोटो दस्तावेज़",
  GroupDoc: "समूह दस्तावेज़",
  LandDoc: "भूमि दस्तावेज़",
  NO_DATA_FOUND: "कोई परिणाम नहीं मिला",
  COMMON_SEARCH: "खोजें",
  REWAMP_GLOBAL_SEARCH: "खोजें",
  REWAMP_ERROR_BOUNDARY_TITLE: "कुछ गलत हो गया",
  REWAMP_ERROR_BOUNDARY_BODY:
    "यह पृष्ठ प्रदर्शित नहीं किया जा सका। आप पुनः प्रयास कर सकते हैं, या मुख पृष्ठ पर वापस जा सकते हैं।",
  REWAMP_ERROR_BOUNDARY_RETRY: "पुनः प्रयास करें",
  COMMON_RESET: "रीसेट",
  COMMON_CLEAR: "साफ करें",
  ClearAll: "सभी साफ़ करें",
  REWAMP_RECENT_SEARCHES: "हाल की खोजें",
  REWAMP_SEARCH_LINK_UNAVAILABLE: "क्षमा करें, यह परिणाम अभी उपलब्ध नहीं है।",
  REWAMP_SEARCH_VIDEO_DIALOG:
    "यह वीडियो YouTube पर खुलेगा, जो एक बाहरी वेबसाइट है। कृपया ध्यान दें कि बिहार कृषि वेबसाइट बाहरी वेबसाइटों की सामग्री और गोपनीयता नीतियों के लिए उत्तरदायी नहीं हो सकती।",
  REWAMP_RECENT_SEARCH_REMOVE: "हाल की खोज हटाएं",
  FARMER_AGE_DISTRIBUTION: "किसानों की आयु वितरण",
  FARMER_GENDER_DISTRIBUTION: "किसानों का लिंग वितरण",
  FARMER_TYPE_DISTRIBUTION: "किसानों के प्रकार का वितरण",
  GA4_FARMER_CATEGORY: "किसान श्रेणी वितरण",
  GA4_DAILY_USER_RETENTION: "दैनिक उपयोगकर्ता प्रतिधारण",
  CUMULATIVE_ACTIVE_USERS: "संचयी सक्रिय उपयोगकर्ता",
  DSS_NOTIFICATION_READ_RATE: "सूचना पठन दर",
  DSS_CALL_CENTER: "कॉल सेंटर",
  DSS_SCHEME_AWARENESS: "योजना जागरूकता",
  DSS_ADVISORY_READ_RATE: "सलाह पठन दर",
  ANDROID_VERSION: "ऑपरेटिंग सिस्टम संस्करण वितरण",
  FARMER_CATEGORY_DISTRIBUTION: "किसान श्रेणी वितरण",
  SCHEME_APPLICATION_GENDER: "योजना आवेदन के लिए लिंग वितरण",
  DSS_SCHEME_ENROLLMENT_BIFURCATION: "योजना नामांकन का विवरण",
  DSS_SCHEME_FARMERS_CATEGORY_WISE_DISTRIBUTION: "योजना के किसानों का श्रेणीवार वितरण",
  DSS_FARMERS_REGISTERED_BY_GENDER: "लिंग के आधार पर किसान पंजीकरण",
  DSS_SESSION_FREQUENCY_DISTRIBUTION: "उपयोगकर्ता सत्र आवृत्ति",

  // summary kpi
  DSS_FARMERS_REGISTERED_SUMMARY: "पंजीकरण",
  GA4_SCHEME_REGISTRATIONS: "योजनाएँ",
  DSS_GRIEVANCE_COUNT_SUMMARY: "शिकायतें (GRM)",
  ACTIVE_USERS: "सक्रिय उपयोगकर्ता",
  AVERAGE_SESSION_DURATION: "औसत सत्र अवधि (HH:MM:SS)",

  MALE: "पुरुष",
  FEMALE: "महिला",
  OTHER: "अन्य",

  AGE: "आयु",
  GENDER: "लिंग",
  FARMER_TYPE: "किसान का प्रकार",
  CASTE_CATEGORY: "जाति श्रेणी",
  FARMER_CATEGORY: "किसान की श्रेणी",
  DISTRICT: "जिला",
  BLOCK: "ब्लॉक",
  PANCHAYAT: "पंचायत",
  VILLAGE: "गाँव",

  // DSS Filters - Geographic
  DSS_DISTRICTS: "जिले",
  DSS_BLOCKS: "ब्लॉक",
  DSS_PANCHAYATS: "पंचायतें",
  DSS_VILLAGES: "गाँव",
  DSS_SELECT_GEOGRAPHICAL: "भौगोलिक चुनें",
  DSS_SELECT_DEMOGRAPHICAL: "जनसांख्यिकीय चुनें",
  DSS_GEOGRAPHICS: "भौगोलिक",
  DSS_DEMOGRAPHICS: "जनसांख्यिकी",
  DSS_FILTERS: "फ़िल्टर",

  // DSS Filters - JEEVIKA (CLF → VO → SHG)
  DSS_FILTER_JEEVIKA: "जीविका",
  DSS_JEEVIKA_SELECT: "जीविका चुनें",
  DSS_JEEVIKA_CLF: "संकुल स्तरीय संघ (CLF)",
  DSS_JEEVIKA_VO: "ग्राम संगठन (VO)",
  DSS_JEEVIKA_SHG: "स्वयं सहायता समूह (SHG)",
  DSS_JEEVIKA_GROUPS_DISTRIBUTION: "जीविका समूह वितरण",
  DSS_IS_JEEVIKA_MEMBER: "जीविका सदस्य",

  // DSS Filters - Demographic Options
  DSS_GENDER: "लिंग",
  DSS_GENDER_MALE: "पुरुष",
  DSS_GENDER_FEMALE: "महिला",
  DSS_GENDER_OTHER: "अन्य",
  DSS_AGE: "आयु",
  DSS_AGE_18_25: "18-25 वर्ष",
  DSS_AGE_26_35: "26-35 वर्ष",
  DSS_AGE_36_45: "36-45 वर्ष",
  DSS_AGE_46_60: "46-60 वर्ष",
  DSS_AGE_60_PLUS: "60+ वर्ष",
  DSS_FARMER_CATEGORY: "किसान श्रेणी",
  DSS_FARMER_SMALL: "लघु किसान",
  DSS_FARMER_MEDIUM: "मध्यम किसान",
  DSS_FARMER_LARGE: "बड़े किसान",
  DSS_FARMER_MARGINAL: "सीमांत किसान",
  DSS_SMALL_MARGINAL_FARMER_PENETRATION: "लघु-सीमांत किसान पहुंच",

  // DSS Dashboard Categories
  DSS_CATEGORY_USER_STICKINESS: "यूजर स्टिकनेस",
  DSS_CATEGORY_DEMOGRAPHICS: "आबादी का विवरण",
  DSS_CATEGORY_VERSION_DETAILS: "वर्ज़न विवरण",
  DSS_CATEGORY_PROFILE: "प्रोफ़ाइल",
  DSS_CATEGORY_MARKETING: "मार्केटिंग",
  DSS_CATEGORY_COMPARE: "तुलना करें",
  DSS_COMPARE: "तुलना करें",
  DSS_COMPARE_DASHBOARDS: "डैशबोर्ड",
  DSS_COMPARE_CHARTS: "चार्ट",
  DSS_COMPARE_EMPTY_HINT: "यहाँ तुलना करने के लिए तुलना फ़िल्टर से डैशबोर्ड और चार्ट चुनें।",
  DSS_COMPARE_MODE_NORMAL: "डैशबोर्ड",
  DSS_COMPARE_MODE_TEMPORAL: "समय अवधि",
  DSS_COMPARE_TEMPORAL_EMPTY_HINT: "किसी चार्ट की विभिन्न तिथि अवधियों में तुलना करने के लिए फ़िल्टर पैनल में कार्ड जोड़ें।",
  DSS_TEMPORAL_RANGES: "तिथि अवधियाँ",
  DSS_TEMPORAL_ADD_RANGE: "अवधि जोड़ें",
  DSS_TEMPORAL_MAX_RANGES: "अधिकतम {{count}} अवधियाँ",
  DSS_TEMPORAL_RANGE_NAME: "अवधि का नाम",
  DSS_TEMPORAL_DELETE_RANGE: "अवधि हटाएँ",
  DSS_TEMPORAL_FILTERS_NOTE: "फ़िल्टर सभी अवधियों पर लागू होते हैं; केवल तिथि अवधि भिन्न होती है।",
  DSS_TEMPORAL_CARDS: "कार्ड",
  DSS_TEMPORAL_NO_CHARTS: "अवधियों में तुलना करने के लिए ऊपर चार्ट चुनें।",
  DSS_TEMPORAL_NO_CARDS: "अभी कोई कार्ड नहीं — किसी चार्ट की अवधि में तुलना के लिए एक जोड़ें।",
  DSS_TEMPORAL_ADD_CARD: "कार्ड जोड़ें",
  DSS_TEMPORAL_MAX_CARDS: "अधिकतम {{count}} कार्ड",
  DSS_TEMPORAL_DELETE_CARD: "कार्ड हटाएँ",
  DSS_DASHBOARD_FARMER_REGISTRATION: "किसान पंजीकरण",
  DSS_DASHBOARD_SCHEME: "योजना आवेदन",
  DSS_DASHBOARD_GRM: "शिकायतें",
  FEATURE_USAGE_DASHBOARD: "फ़ीचर का उपयोग",
  DSS_FEATURE_USAGE: "फ़ीचर का उपयोग",
  DSS_CLICKS_DASHBOARD: "क्लिक",
  DSS_UNIQUE_CLICKS: "अनोखे क्लिक",
  DSS_TOTAL_CLICKS: "कुल क्लिक",
  GA4_OFFLINE_MODE_USAGE: "ऑफ़लाइन मोड उपयोग",
  APP_VERSION: "ऐप संस्करण",
  LOAD_TIME: "लोड समय",

  // Filter Key Translations
  DSS_FILTER_GEOGRAPHY: "भूगोल",

  // Device Options
  DSS_DEVICE_MOBILE: "मोबाइल",
  DSS_DEVICE_TABLET: "टेबलेट",
  DSS_DEVICE_DESKTOP: "डेस्कटॉप",

  // DSS Sort
  DSS_SORT_BY: "क्रमबद्ध करें",
  DSS_HIGH_TO_LOW: "उच्च से निम्न",
  DSS_LOW_TO_HIGH: "निम्न से उच्च",

  // DSS Performers matrix (top / lowest side panels)
  DSS_TOP_PERFORMERS: "शीर्ष प्रदर्शक",
  DSS_LOWEST_PERFORMERS: "निम्नतम प्रदर्शक",

  // DSS Pie Chart Display
  DSS_DISPLAY_VALUE: "मान प्रदर्शित करें",
  DSS_VALUE_AND_PERCENT: "मान और प्रतिशत",
  DSS_PERCENT_ONLY: "केवल प्रतिशत",
  DSS_HIDE_SMALL_SLICES: "{{cutoff}}% से छोटे हिस्से छिपाएँ",
  DSS_LEGEND_PREV_PAGE: "लेजेंड का पिछला पृष्ठ",
  DSS_LEGEND_NEXT_PAGE: "लेजेंड का अगला पृष्ठ",
  DSS_VALUE_ONLY: "केवल मान",
  DSS_VALUE_ABSOLUTE: "निरपेक्ष",

  DSS_SCHEME_FARMERS_CASTE_WISE_DISTRIBUTION: "किसान जाति के आधार पर योजना वितरण",
  DSS_SCHEME_FARMERS_TYPE_WISE_DISTRIBUTION: "किसान प्रकार के आधार पर योजना वितरण",

  // Filter Warning Messages
  DSS_FILTER_WARNING: "कुछ फ़िल्टर लागू नहीं",
  DSS_FILTERS_NOT_APPLICABLE: "निम्नलिखित फ़िल्टर इस चार्ट पर लागू नहीं हैं:",

  // Farmer Types
  DSS_TYPE_SMALL: "लघु किसान (1-2 हेक्टेअर)",
  DSS_TYPE_MARGINAL: "सीमांत किसान (1 हेक्टेअर से कम)",
  DSS_TYPE_LARGE: "बृहत किसान (2 हेक्टेअर से ज्यादा)",
  DSS_TYPE_TENANT: "रैयत",
  DSS_TYPE_NON_TENANT: "गैर-रैयत",
  DSS_TYPE_NOT_AVAILABLE: "उपलब्ध नहीं है",

  // Caste Categories
  DSS_CASTE_GEN: "सामान्य",
  DSS_CASTE_OBC: "अन्य पिछड़ा वर्ग",
  DSS_CASTE_EBC: "अत्यंत पिछड़ा वर्ग",
  DSS_CASTE_SC: "अनुसूचित जाति",
  DSS_CASTE_ST: "अनुसूचित जनजाति",
  DSS_CASTE_MINORITY: "अल्पसंख्यक",

  DSS_FILTER_GENDER: "लिंग",
  DSS_FILTER_AGE: "आयु",
  DSS_FILTER_FARMER_CATEGORY: "किसान श्रेणी",
  DSS_FILTER_ANDROID_VERSION: "एंड्रॉइड संस्करण",
  DSS_FILTER_DEVICE: "डिवाइस",
  DSS_FILTER_SCHEME: "योजना",
  DSS_FILTER_TIME: "दिनांक",

  // Chart Indicators
  DSS_CHARTS: "चार्ट",
  DSS_DIRECT_VIEW: "सारांश",
  DSS_PRESENTATIONAL_VIEW: "विस्तृत दृश्य",

  // Chart type switcher labels
  DSS_CHART_TYPE_DONUT: "डोनट",
  DSS_CHART_TYPE_LINE: "रेखा",
  DSS_CHART_TYPE_HORIZONTAL_BAR: "क्षैतिज बार",
  DSS_CHART_TYPE_STACKED_BAR: "स्टैक्ड बार",
  DSS_CHART_TYPE_STACKED_COLUMN: "स्टैक्ड कॉलम",
  // Date picker labels (if not already present)
  DSS_SELECT_DATE_RANGE: "दिनांक सीमा चुनें",
  DSS_START_DATE: "आरंभिक दिनांक",
  DSS_END_DATE: "अंतिम दिनांक",
  DSS_TODAY: "आज",
  DSS_YESTERDAY: "बीता हुआ कल",
  DSS_THIS_WEEK: "यह सप्ताह",
  DSS_PREVIOUS_WEEK: "पिछला सप्ताह",
  DSS_THIS_MONTH: "यह महीना",
  DSS_PREVIOUS_MONTH: "पिछला महीना",
  DSS_THIS_YEAR: "यह वर्ष",
  DSS_PREVIOUS_YEAR: "पिछला वर्ष",
  DSS_CUSTOM: "कस्टम",

  // Update Frequency Labels
  DSS_FREQUENCY_INSTANTANEOUS: "तात्कालिक",
  DSS_FREQUENCY_DAILY: "दैनिक",
  DSS_FREQUENCY_WEEKLY: "साप्ताहिक",
  DSS_FREQUENCY_MONTHLY: "मासिक",
  DSS_FREQUENCY_QUARTERLY: "त्रैमासिक",
  DSS_FREQUENCY_YEARLY: "वार्षिक",
  DSS_UPDATE_FREQUENCY: "अद्यतन आवृत्ति",

  GA4_FARMER_LAND_OWNERSHIP_CATEGORY: "किसान भूमि स्वामित्व श्रेणी",
  DSS_GEOGRAPHIC_DISTIBUTION: "भौगोलिक वितरण",
  DSS_AVERAGE_APP_STORE_RATING: "औसत ऐप स्टोर रेटिंग",
  DSS_SCHEMES_DASHBOARDS: "योजनाएँ",
  FARMER_CASTE_DISTRIBUTION: "किसानों का जातिवार वितरण",
  DSS_SCHEME_ENROLLMENT_DISTIBUTION: "योजना नामांकन",

  // Interval Options
  DSS_INTERVAL: "अंतराल",
  DSS_INTERVAL_DAY: "दैनिक",
  DSS_INTERVAL_WEEK: "साप्ताहिक",
  DSS_INTERVAL_MONTH: "मासिक",
  DSS_INTERVAL_QUARTER: "त्रैमासिक",
  DSS_INTERVAL_YEAR: "वार्षिक",
  DSS_SELECT_INTERVAL: "अंतराल चुनें",
  DSS_CHART_FREQUENCY: "चार्ट आवृत्ति",
  DSS_FREQUENCY_AUTO: "स्वचालित",
  WOMAN_FARMER_ADOPTION_DISTRIBUTION: "महिला किसान स्वीकृति वितरण",
  DSS_CURRENT_LEVEL: "वर्तमान स्तर",
  DSS_STATE: "राज्य",
  DSS_DISTRICT: "जिला",
  DSS_BLOCK: "प्रखंड",
  DSS_PANCHAYAT: "पंचायत",
  DSS_VILLAGE: "गाँव",
  DSS_VALUE: "मान",
  DSS_OTHER: "अन्य",
  DSS_NOT_AVAILABLE: "उपलब्ध नहीं है",
  DSS_FILTERS_APPLIED: "लागू फ़िल्टर",
  DSS_NO_DATA_FOR_DRILL: "इस ड्रिल पैरामीटर के लिए कोई डेटा नहीं है",
  GA4_MONTHLY_ACTIVE_USERS: "मासिक सक्रिय उपयोगकर्ता",
  GA4_MONTHLY_DAU_PER_MAU_DISTRIBUTION: "मासिक DAU/MAU वितरण",

  पुरुष: "पुरुष",
  स्त्री: "स्त्री",
  अन्य: "अन्य",
  NoOptions: "कोई विकल्प नहीं",
  DSS_TOTAL: "कुल",
  DSS_DOWNLOAD_EXCEL: "एक्सेल डाउनलोड करें",
  DSS_DOWNLOAD_CSV: "सीएसवी डाउनलोड करें",
  DSS_DOWNLOAD_PDF: "पीडीएफ डाउनलोड करें",
  DSS_DOWNLOAD_SVG: "एसवीजी डाउनलोड करें",
  DSS_DOWNLOAD_JPEG: "जेपीईजी डाउनलोड करें",
  DSS_DOWNLOAD_REPORT: "रिपोर्ट डाउनलोड करें",
  DSS_EXPORT_SUBMITTING: "आपकी रिपोर्ट का अनुरोध किया जा रहा है…",
  DSS_EXPORT_PREPARING: "आपकी रिपोर्ट तैयार की जा रही है…",
  DSS_EXPORT_DOWNLOADING: "डाउनलोड हो रहा है…",
  DSS_EXPORT_DOWNLOADING_PART: "भाग {{current}} / {{total}} डाउनलोड हो रहा है…",
  DSS_EXPORT_READY: "आपकी रिपोर्ट तैयार है — डाउनलोड शुरू हो गया।",
  DSS_EXPORT_READY_PARTS: "आपकी रिपोर्ट तैयार है — {{count}} फ़ाइलें।",
  DSS_EXPORT_PARTS_COUNT: "{{count}} फ़ाइलें",
  DSS_EXPORT_PART: "भाग {{seq}}",
  DSS_EXPORT_DOWNLOAD_ALL: "सभी डाउनलोड करें",
  DSS_EXPORT_FAILED: "रिपोर्ट निर्यात विफल रहा।",
  DSS_EXPORT_STATUS_REFRESH: "स्थिति ताज़ा करें",
  DSS_EXPORT_CLOSE: "बंद करें",

  DSS_OWNERSHIP_RAIYAT: "रैयत",
  DSS_OWNERSHIP_NON_RAIYAT: "गैर-रैयत",
  DSS_OWNERSHIP_RAIYAT_NON_RAIYAT: "रैयत-गैर-रैयत",

  "by district": "जिलावार",
  "by block": "प्रखंडवार",
  "by panchayat": "पंचायतवार",
  "by village": "ग्रामवार",

  "by quarter": "तिमाहीवार",
  "by year": "वार्षिक",
  "by month": "मासिक",
  "by week": "साप्ताहिक",
  "by day": "दैनिक",

  "by gender": "लिंगवार",
  "by age": "आयुवार",
  "by farmer category": "किसान श्रेणीवार",
  "by android version": "एंड्रॉइड संस्करणवार",
  "by device": "डिवाइसवार",
  "by scheme": "योजनावार",
  "by time": "समयवार",

  "by date": "दिनांकवार",

  "0th month": "0वां महीना",
  "1st month": "1वां महीना",
  "2nd month": "2वां महीना",

  "0th week": "0वां सप्ताह",
  "1st week": "1वां सप्ताह",
  "2nd week": "2वां सप्ताह",
  "3rd week": "3वां सप्ताह",
  "4th week": "4वां सप्ताह",

  "0th day": "0वां दिन",
  "1st day": "1वां दिन",
  "2nd day": "2वां दिन",
  "3rd day": "3वां दिन",
  "4th day": "4वां दिन",
  "5th day": "5वां दिन",
  "6th day": "6वां दिन",
  "7th day": "7वां दिन",

  "Other": "अन्य",

  "ComingSoon": "जल्द आ रहा है…",

  DSS_FILTER_FEATURE: "फ़ीचर",
  DSS_FEATURE_GROUP: "फ़ीचर समूह",
  DSS_FEATURE_SUB_GROUP: "फ़ीचर उप समूह",
  DSS_FEATURE_NAME: "फ़ीचर नाम",
  // Generic hierarchy levels
  DSS_LEVEL_0: "स्तर 0",
  DSS_LEVEL_1: "स्तर 1",
  DSS_LEVEL_2: "स्तर 2",
  DSS_LEVEL_3: "स्तर 3",
  DSS_LEVEL_4: "स्तर 4",
  DSS_LEVEL_5: "स्तर 5",

  DSS_FEATURE_HOME: "होम",
  DSS_FEATURE_ASSETS: "कृषि संसाधन",
  DSS_FEATURE_ADVISORY: "सलाह",
  DSS_FEATURE_HELP: "सहायता",
  DSS_FEATURE_OTHERS: "अन्य",

  DSS_FEATURE_SUB_GROUP_SCREEN: "स्क्रीन",
  DSS_FEATURE_SUB_GROUP_CAROUSEL: "कैरोसेल",
  DSS_FEATURE_SUB_GROUP_SCHEMES: "योजनाएँ",
  DSS_FEATURE_SUB_GROUP_SCHEME_DETAILS: "योजना विवरण",
  DSS_FEATURE_SUB_GROUP_SCHEME_APPLICATION: "योजना अप्लिकेशन",
  DSS_FEATURE_SUB_GROUP_FARMER_PASSBOOK: "किसान पासबुक",
  DSS_FEATURE_SUB_GROUP_ASSET: "संस्थान",
  DSS_FEATURE_SUB_GROUP_ASSET_LISTS: "संस्थान सूची",
  DSS_FEATURE_SUB_GROUP_SPECIALIZED_ASSETS: "विशेष संस्थान",
  DSS_FEATURE_SUB_GROUP_MANDI_PRICE: "मंडी मूल्य",
  DSS_FEATURE_SUB_GROUP_WEATHER: "मौसम",
  DSS_FEATURE_SUB_GROUP_PLANT_PROTECTION: "पौधा संरक्षण",
  DSS_FEATURE_SUB_GROUP_SOIL_HEALTH: "मृदा स्वास्थ्य",
  DSS_FEATURE_SUB_GROUP_KNOWLEDGE_SECTION: "ज्ञान सेक्शन",
  DSS_FEATURE_SUB_GROUP_HELP_AND_SUPPORT: "सहायता",
  DSS_FEATURE_SUB_GROUP_GRM: "जीआरएम",
  DSS_FEATURE_SUB_GROUP_TECHNICAL_SUPPORT: "तकनीकी सहायता",
  DSS_FEATURE_SUB_GROUP_USER_ROLES: "उपयोगकर्ता भूमिकाएँ",
  DSS_FEATURE_SUB_GROUP_REGISTRATION: "पंजीकरण",
  DSS_FEATURE_SUB_GROUP_OTHERS: "अन्य",

  SearchCityOrStation: "शहर या स्टेशन खोजें",
  AirQualityIndex: "वायु गुणवत्ता सूचकांक",
  WeatherLocationError: "इस स्थान के लिए मौसम डेटा उपलब्ध नहीं है। आपके वर्तमान क्षेत्र का डेटा दिखाया जा रहा है।",
  good: "उत्तम",
  satisfactory: "संतोषजनक",
  moderate: "सामान्य",
  poor: "खराब",
  verypoor: "बहुत खराब",
  severe: "खतरनाक",
  unableToDecide: "ए.क्यू.आई डेटा उपलब्ध नहीं है। कृपया पुनः प्रयास करें।",
  aqiIndex: "एक्यूआई इन्‌डे᠎क्‍स्",
  healthImpact: "स्वास्थ्य प्रभाव",
  monitoringStation: "मॉनिटरिंग स्टेशन",

  // Rewamp Main Landing Page
  "— QUICK ACCESS": "— त्वरित पहुँच",
  "Popular resources": "लोकप्रिय संसाधन",
  "CHATBOT — AI Powered": "एआई-संचालित चैटबॉट",
  "Bihar Krishi AI — Your AI Farming Assistant":
    "बिहार कृषि AI - आपका AI खेती सहायक",
  "Ask questions in Hindi or English about crop care, pest management, weather impact, and scheme eligibility, with guidance based on ICAR and Bihar agricultural extension services.":
    "फसल देखभाल, कीट प्रबंधन, मौसम के प्रभाव और योजना पात्रता से जुड़े सवाल हिंदी या अंग्रेजी में पूछें। मार्गदर्शन ICAR और बिहार कृषि विस्तार सेवाओं पर आधारित है।",
  "Try Bihar Krishi AI": "बिहार कृषि AI आज़माएँ",
  "Bihar Krishi AI chat demo: a farmer asks about yellow wheat leaves and receives advice in Hindi":
    "बिहार कृषि एआई चैट डेमो: किसान गेहूं की पीली पत्तियों के बारे में पूछता है और हिंदी में सलाह प्राप्त करता है",
  "Your browser does not support embedded video. Read the chat transcript below.":
    "आपका ब्राउज़र एम्बेडेड वीडियो का समर्थन नहीं करता है। नीचे चैट ट्रांसक्रिप्ट पढ़ें।",
  "View chat transcript": "चैट ट्रांसक्रिप्ट देखें",
  AI_CHAT_DEMO_TRANSCRIPT: "एआई चैट डेमो ट्रांसक्रिप्ट",

  "— WEATHER": "— मौसम",
  "Weather forecast": "मौसम पूर्वानुमान",
  Patna: "पटना",
  "Mostly Sunny": "अधिकांशतः धूप",
  "Wind Direction": "हवा की दिशा",
  "Wind SPEED": "हवा की गति",
  "Heavy Rainfall Alert": "भारी वर्षा की चेतावनी",
  "Avoid field work. Risk of waterlogging in your district. Secure crops immediately.":
    "खेत में काम करने से बचें। आपके जिले में जलभराव का जोखिम है। फसलों को तुरंत सुरक्षित करें।",
  "Forecast View Options": "पूर्वानुमान देखने के विकल्प",
  "3-Day Forecast": "3 दिनों का पूर्वानुमान",
  "7-Day Forecast": "7 दिनों का पूर्वानुमान",
  "3 Days": "3 दिन",
  "7 Days": "7 दिन",
  "Source: ": "स्रोत: ",

  "Announcements and FAQ": "घोषणाएं और अक्सर पूछे जाने वाले प्रश्न",
  "— Stay Updated": "अपडेट रहें",
  "News & Announcement": "समाचार एवं घोषणाएँ",
  All: "सभी",
  Archived: "संग्रहित",
  Feb: "फरवरी",
  "PM-KISAN 17th Installment — Verification closes 28 February":
    "पीएम-किसान 17वीं किस्त - सत्यापन 28 फरवरी को बंद होगा",
  "Complete eKYC verification before deadline to receive the next installment":
    "अगली किस्त प्राप्त करने के लिए अंतिम तिथि से पहले ई-केवाईसी सत्यापन पूरा करें।",
  "Direct Subsidy Scheme 2025-26 — Online applications now open":
    "प्रत्यक्ष सब्सिडी योजना 2025-26 - ऑनलाइन आवेदन अब खुले हैं",
  "Farmers can download updated soil health cards from the portal":
    "किसान पोर्टल से अपडेटेड मृदा स्वास्थ्य कार्ड डाउनलोड कर सकते हैं।",
  "— HAVE QUESTIONS": "प्रश्न पूछें",
  "Frequently Asked Questions": "अक्सर पूछे जाने वाले प्रश्न",
  "View all": "सभी देखें",
  General: "सामान्य",
  "Kisan Call Centre": "किसान कॉल सेंटर",
  Advisory: "सलाह",
  "Who is eligible to register on Bihar Krishi?":
    "बिहार कृषि पर पंजीकरण के लिए कौन पात्र है?",
  "All farmers residing in Bihar with valid agricultural land records (LPC, DBT registration) are eligible to register and access benefits.":
    "बिहार में रहने वाले सभी किसान, जिनके पास वैध कृषि भूमि अभिलेख, एलपीसी या डीबीटी पंजीकरण है, पंजीकरण कर लाभ प्राप्त कर सकते हैं।",
  "How do I contact the Kisan Call Centre?":
    "मैं किसान कॉल सेंटर से कैसे संपर्क करूं?",
  "You can reach the Kisan Call Centre toll-free by dialing 1800-180-1551 from any mobile or landline.":
    "आप किसी भी मोबाइल या लैंडलाइन से 1800-180-1551 डायल करके किसान कॉल सेंटर से टोल-फ्री संपर्क कर सकते हैं।",
  "Where can I check the status of my application?":
    "मैं अपने आवेदन की स्थिति कहां देख सकता हूं?",
  "Login to the portal using your Aadhaar or Mobile Number and go to the 'My Applications' section to check the real-time status.":
    "अपने आधार या मोबाइल नंबर से पोर्टल में लॉग इन करें और वास्तविक समय की स्थिति देखने के लिए 'मेरे आवेदन' अनुभाग में जाएं।",
  "How do I access district-specific weather advisory?":
    "मैं जिले-विशेष मौसम सलाह कैसे देख सकता हूं?",
  "Navigate to the Weather Section on the home page, select your district, and view the latest agro-meteorological advisories.":
    "होम पेज पर मौसम अनुभाग में जाएं, अपना जिला चुनें और नवीनतम कृषि-मौसम संबंधी सलाह देखें।",
  "No FAQs available for this category.":
    "इस श्रेणी के लिए कोई अक्सर पूछे जाने वाले प्रश्न उपलब्ध नहीं हैं।",

  "Download Bihar Krishi, farm smarter from your pocket":
    "बिहार कृषि डाउनलोड करें और अपने फोन से स्मार्ट खेती करें",
  "Get instant access to scheme applications, crop advisories, market prices, and AI-powered farm assistance — all optimised for low-bandwidth and available offline in Hindi.":
    "योजना आवेदन, फसल सलाह, बाजार भाव और एआई-संचालित कृषि सहायता तुरंत पाएं - कम बैंडविड्थ के लिए अनुकूलित और हिंदी में ऑफलाइन उपलब्ध।",
  "Apply for schemes directly from your phone":
    "सीधे अपने फोन से योजनाओं के लिए आवेदन करें",
  "Real-time weather & pest alerts via notification":
    "नोटिफिकेशन के माध्यम से रियल-टाइम मौसम और कीट अलर्ट पाएं",
  "Track DBT payments & application status":
    "डीबीटी भुगतान और आवेदन की स्थिति ट्रैक करें",
  "GET IT ON": "यहां उपलब्ध",
  "Google Play": "गूगल प्ले",
  Download_QR_Code: "डाउनलोड क्यूआर कोड",

  // alt text
  BIHAR_KRISHI_LOGO: "बिहार कृषि लोगो",
  BIHAR_KRISHI_SHAHAYAK_LOGO: "बिहार कृषि सहायक लोगो",
  BIHAR_KRISHI_RADIO_LOGO: "बिहार कृषि रेडियो लोगो",
  GOVT_OF_BIHAR_EMBLEM: "बिहार सरकार का प्रतीक चिह्न",
  SCHEME_LOGO: "योजना लोगो",


  TOGGLE_THEME: "थीम बदलें",
  PLAY_OR_PAUSE: "चलाएं या रोकें",
  IMPORTANT_UPDATES: "महत्वपूर्ण अपडेट",
  Announcements: "घोषणाएं",
  Slide: "स्लाइड",
  SLIDE: "स्लाइड",
  BANNER_CAROUSEL_LABEL: "बैनर कैरोसेल",
  CAROUSEL_CONTROLS: "कैरोसेल नियंत्रण",
  SLIDE_INDICATORS: "स्लाइड सूचक",
  NO_IMAGE: "कोई छवि उपलब्ध नहीं",
  "— SUPPORT": "— सहायता",
  "Help & Support": "सहायता एवं समर्थन",
  "Explore more": "और ज्यादा खोजें",
  Explore: "देखें",
  Today: "आज",
  Humidity: "नमी",
  "Wind Speed": "हवा की गति",
  Rainfall: "वर्षा",
  Cloudy: "बादल",
  Rainy: "बारिश",
  Sunny: "धूप",
  Clear: "साफ़ आसमान",
  "Partly Cloudy": "आंशिक रूप से बादल",
  "Mostly Cloudy": "अधिकांशतः बादल",
  Overcast: "घने बादल",
  Showers: "बौछारें",
  Thunderstorm: "आंधी-तूफ़ान",
  Storm: "तूफ़ान",
  Windy: "तेज़ हवा",
  Fog: "कोहरा",
  Drought: "सूखा",
  Winter: "सर्दी",
  Night: "रात",
  Forecast: "मौसम पूर्वानुमान",
  "Weather data unavailable": "मौसम डेटा अनुपलब्ध",
  "We're unable to fetch weather information right now. This could be due to a temporary issue with the IMD data source.":
    "हम अभी मौसम की जानकारी प्राप्त नहीं कर पा रहे हैं। यह IMD डेटा स्रोत में अस्थायी समस्या के कारण हो सकता है।",
  Retry: "पुनः प्रयास करें",
  "Weather advisory": "मौसम सलाह",
  "Advisory — Stay informed": "मौसम सलाह — अपडेट रहें",
  "Yellow Alert — Be Aware": "पीला अलर्ट — सतर्क रहें",
  "Orange Alert — Be Prepared": "नारंगी अलर्ट — तैयार रहें",
  "Red Alert — Immediate action required": "लाल अलर्ट — तत्काल कार्रवाई आवश्यक",
  "Humidity icon": "आर्द्रता आइकन",
  "Wind direction icon": "हवा की दिशा आइकन",
  "Wind speed icon": "हवा की गति आइकन",
  "Rainfall icon": "वर्षा आइकन",
  Partner_Logos_Carousel: "साझेदार लोगो कैरोसेल",
  Partner_Logos_Section: "साझेदार लोगो",
  Partner_Logos_Pagination: "साझेदार लोगो पेजिनेशन",
  Visit_Website: "वेबसाइट पर जाएं",
  Go_To_Slide: "स्लाइड पर जाएं",
  "Krishi Vibhaag Logo": "कृषि विभाग लोगो",
  "PM Kisan Logo": "पीएम किसान लोगो",
  "MyScheme Logo": "माइस्कीम लोगो",
  "Organic Certification Logo": "जैविक प्रमाणन लोगो",
  "Food Security Logo": "खाद्य सुरक्षा लोगो",
  "Horticulture Development Logo": "उद्यान विकास लोगो",
  "BRBN Logo": "BRBN लोगो",
  "Rabi Season Active": "रबी सीज़न सक्रिय",
  // Crop-advisory active-season badge: season display names (MDMS code →
  // localized) + the "{{season}} Season Active" template.
  REWAMP_SEASON_ZAID: "ज़ायद",
  REWAMP_SEASON_KHARIF: "खरीफ",
  REWAMP_SEASON_RABI: "रबी",
  CS_SEASON_ACTIVE: "सीज़न सक्रिय",
  REWAMP_CROP_SEASON_ACTIVE_LABEL: "{{season}} सीज़न सक्रिय",
  "Explore Plant Protection Advisory": "पौधा संरक्षण सलाह अन्वेषण करें",
  "Crop Selection": "फसल चयन",
  CATEGORIES_EYEBROW: "— सेवाएं",
  CROP_ADVISORY_SUBHEADING:
    "रोग विवरण, अनुशंसित पद्धतियां, रोकथाम के तरीके और उपचार समाधान देखने के लिए नीचे किसी फसल के नाम पर क्लिक करें।",
  "Unable to load advisory details. Please try again later.":
    "सलाह विवरण लोड नहीं हो सका। कृपया कुछ समय बाद पुनः प्रयास करें।",
  "No advisory information available for this crop.":
    "इस फसल के लिए कोई सलाह जानकारी उपलब्ध नहीं है।",
  MAIN_NAVIGATION: "मुख्य नेविगेशन",
  OPEN_NAVIGATION: "नेविगेशन मेनू खोलें",
  CLOSE_NAVIGATION: "नेविगेशन मेनू बंद करें",
  More: "अधिक",
  IMPORTANT_UPDATES_CAROUSEL_MOBILE: "महत्वपूर्ण अपडेट कैरोसेल (मोबाइल)",
  IMPORTANT_UPDATES_CAROUSEL_DESKTOP: "महत्वपूर्ण अपडेट कैरोसेल (डेस्कटॉप)",

  Volume_Level: "आवाज़ का स्तर",

  pending: "लंबित",
  uploading: "अपलोड हो रहा है",
  success: "सफल",
  error: "त्रुटि",

  toDate: "अंतिम दिनांक",
  fromDate: "आरंभिक दिनांक",

  LOGO: "चित्र",
  TWEET_MEDIA: "ट्वीट मीडिया",

  EXAMPLE_EMAIL: "जैसे: mukesh1234@email.com",

  SearchQuestion: "प्रश्न खोजें",

  // DSS Feature Groups
  DSS_FEATURE_NEWS_AND_NOTIFICATIONS: "समाचार और सूचनाएं",
  DSS_FEATURE_KNOWLEDGE: "ज्ञान",

  // DSS Feature Sub Groups
  DSS_FEATURE_CAROUSEL: "कैरोसेल",
  DSS_FEATURE_IMPORTANT_LINKS: "महत्वपूर्ण लिंक",
  DSS_FEATURE_NOTIFICATIONS: "सूचनाएं",
  DSS_FEATURE_GRM: "जीआरएम",
  DSS_FEATURE_CALL_CENTRE: "कॉल सेंटर",
  DSS_FEATURE_TECHNICAL_SUPPORT: "तकनीकी सहायता",
  DSS_FEATURE_OFFICIALS: "अधिकारी",
  DSS_FEATURE_SCHEMES: "योजनाएँ",
  DSS_FEATURE_SCHEMES_APPLIED: "आवेदित योजनाएँ",
  DSS_FEATURE_FARMER_PASSBOOK: "किसान पासबुक",
  DSS_FEATURE_ASSETS_STORAGE: "स्टोरेज",
  DSS_FEATURE_ASSETS_OFFICES: "कार्यालय",
  DSS_FEATURE_ASSETS_INSTITUTES: "संस्थान",
  DSS_FEATURE_ASSETS_BAZAR: "बाजार",
  DSS_FEATURE_ASSETS_INDUSTRIES: "उद्योग",
  DSS_FEATURE_ASSETS_OTHER: "अन्य संसाधन",
  DSS_FEATURE_AGRI_TIPS: "कृषि सुझाव",
  DSS_FEATURE_WEATHER: "मौसम",
  DSS_FEATURE_SOIL_HEALTH: "मृदा स्वास्थ्य",
  DSS_FEATURE_MANDI: "मंडी",
  DSS_FEATURE_REGISTRATION: "पंजीकरण",
  DSS_FEATURE_PROFILE: "प्रोफ़ाइल",

  // DSS Feature Components - News and Notifications / Carousel
  TwitterCard: "ट्विटर कार्ड",
  AnnouncementCard: "घोषणा कार्ड",

  // DSS Feature Components - News and Notifications / Important Links
  ImportantServicesScreen: "महत्वपूर्ण सेवाएं",
  DbtRelatedUsefulLink: "डीबीटी संबंधित उपयोगी लिंक",

  // DSS Feature Components - News and Notifications / Notifications
  NotificationScreen: "सूचना",

  // DSS Feature Components - Help/GRM
  GrievanceTicketCreation: "शिकायत टिकट निर्माण",
  GrievanceScreen: "शिकायत",

  // DSS Feature Components - Help/Call Centre
  HelpLine: "हेल्पलाइन",
  CallCentre: "कॉल सेंटर",

  // DSS Feature Components - Help/Technical Support
  TechSupportTicketCreation: "तकनीकी सहायता टिकट निर्माण",
  TechnicalSupportScreen: "तकनीकी सहायता स्क्रीन",

  // DSS Feature Components - Help/Officials
  MandiAnalyst: "मंडी विश्लेषक",
  KisanSalahkar: "किसान सलाहकार",
  AgriCoordinator: "कृषि समन्वयक",
  AssistantDirectorPP: "सहायक निदेशक पीपी",
  BosscaInspectors: "बॉस्का निरीक्षक",
  BavasAgriCoordinator: "बावस कृषि समन्वयक",
  SaoUsers: "एसएओ उपयोगकर्ता",

  // DSS Feature Components - Schemes
  Schemes: "योजनाएँ",
  SchemesDetails: "योजना विवरण",
  SchemesDetailsPage: "योजना विवरण पृष्ठ",
  AllSchemes: "सभी योजनाएँ",
  SchemesForm: "योजना फॉर्म",
  SaveSchemeForm: "योजना फॉर्म सहेजें",
  DownloadSchemesDocument: "योजना दस्तावेज़ डाउनलोड करें",
  SchemesListPage: "योजना सूची पृष्ठ",

  // DSS Feature Components - Schemes Applied
  AppliedSchemes: "आवेदित योजनाएँ",
  AppliedSchemesPage: "आवेदित योजना पृष्ठ",

  // DSS Feature Components - Farmer Passbook
  FarmerPassbook: "किसान पासबुक",

  // DSS Feature Components - Assets/Storage
  "Cold Storages": "कोल्ड स्टोरेज",
  "Agri Godowns": "कृषि गोदाम",
  PACS: "पैक्स",

  // DSS Feature Components - Assets/Offices
  "Panchayat Office": "पंचायत कार्यालय",
  "Panchayat Offices": "पंचायत कार्यालय",
  "e-KISAN Bhawans": "ई-किसान भवन",
  "DAO offices": "डीएओ कार्यालय",

  // DSS Feature Components - Assets/Institutes
  KVKs: "कृषि विज्ञान केंद्र",
  "Agriculture Colleges": "कृषि महाविद्यालय",

  // DSS Feature Components - Assets/Bazar
  "Pashu Bazar": "पशु बाजार",
  "Market Nodes": "बाजार समिति",
  FPOs: "एफपीओ",
  "Jaivik FPOs": "जैविक एफपीओ",
  JaivikFPO: "जैविक एफपीओ",

  // DSS Feature Components - Assets/Industries
  foodProcessing: "खाद्य प्रसंस्करण",
  EthanolIndustries: "इथेनॉल उद्योग",

  // DSS Feature Components - Assets/Other
  "Agri-Input Shops": "कृषि-इनपुट उपादान",
  "Agriculture Farms": "कृषि फार्म",
  "Rice Mill": "राइस मिल",
  CHCs: "सीएचसी",
  Traders: "व्यापारी",
  "Seed Dealers": "बीज विक्रेता",
  "सीड डीलर": "बीज विक्रेता",
  Banks: "बैंक",
  "Govt Pond": "सरकारी तालाब",
  "सरकारी तालाब": "सरकारी तालाब",

  // DSS Feature Components - Advisory/Agri Tips
  PlantProtectionAdvisory: "पौधा संरक्षण सलाह",
  StaticAdvisory: "स्थिर सलाह",

  // DSS Feature Components - Advisory/Weather
  WeatherBasedAdvisory: "मौसम आधारित सलाह",

  // DSS Feature Components - Advisory/Soil Health
  SoilHealthLabData: "मृदा स्वास्थ्य प्रयोगशाला डेटा",
  SoilHealthDataAnalysis: "मृदा स्वास्थ्य डेटा विश्लेषण",
  SoilHealthFileDownload: "मृदा स्वास्थ्य फ़ाइल डाउनलोड",

  // DSS Feature Components - Advisory/Mandi
  PriceMandi: "मूल्य मंडी",
  PriceMandiFilter: "मूल्य मंडी फ़िल्टर",
  PriceMandiDetails: "मूल्य मंडी विवरण",

  // DSS Feature Components - Registration
  DbtBasedRegistration: "डीबीटी आधारित पंजीकरण",
  NoDBTRegistration: "गैर-डीबीटी पंजीकरण",

  // DSS Feature Components - Profile
  ProfileCreationDBT: "प्रोफ़ाइल निर्माण डीबीटी",
  LanguageChange: "भाषा परिवर्तन",
  Profile: "प्रोफ़ाइल",

  // DSS Feature Components - Knowledge
  KnowledgeSection: "ज्ञान सेक्शन",
  DSS_DRILL_INTO_VIEW: "{{interval}} दृश्य में विस्तार से देखें",

  Yes: "हाँ",
  No: "नहीं",

  GroupPresidentDBTRegistrationError: "समूह के अध्यक्ष का डीबीटी पंजीकरण नंबर अनिवार्य है।",
  DuplicateDBTRegistrationNumberError: "डुप्लीकेट डीबीटी विवरण।",
  DSS_SELECT_PLACEHOLDER: "चुनें",
  BIHAR_KRISHI_APP: "बिहार कृषि",
  DIGITAL_FARMER_SERVICES: "डिजिटल किसान सेवाएं",
  GOVT_INITIATIVE_DESC: "बिहार के सभी 38 जिलों में किसानों के लिए कृषि सेवाओं को डिजिटल और सुव्यवस्थित करने की बिहार सरकार की एक पहल।",
  FACEBOOK_ICON: "फेसबुक",
  X_ICON: "एक्स",
  X_FEED_CAROUSEL: "एक्स फ़ीड",
  YOUTUBE_ICON: "यूट्यूब",
  INSTAGRAM_ICON: "इंस्टाग्राम",
  WEBSITE_DEVELOPED_BY: "वेबसाइट का विकास एवं प्रबंधन",
  ALL_RIGHTS_RESERVED: "सर्वाधिकार सुरक्षित।",
  TOTAL_VISITS: "कुल विज़िट",
  MAUSAM_SEVA_KENDRA: "मौसम सेवा केंद्र",
  "India Meteorological Department": "India Meteorological Department",
  "भारत मौसम विज्ञान विभाग": "भारत मौसम विज्ञान विभाग",
  DETAILS: "विवरण",
  Details: "विवरण",
  Bihar_Agri_Portal_Logo: "बिहार कृषि पोर्टल",
  NFSM_Logo: "राष्ट्रीय खाद्य सुरक्षा मिशन, भारत सरकार",
  Horticulture_Bihar_Logo: "हॉर्टिकल्चर बिहार",
  Bihar_Beej_Logo: "बिहार राज्य बीज निगम (BRBN)",
  Aadhaar_Logo: "आधार – UIDAI, भारत सरकार",
  Krishi_Vibhaag_Logo: "कृषि विभाग, बिहार सरकार",
  Jal_Sansadhan_Logo: "बिहार जल विकास सोसाइटी (BWDS)",
  BAMETI_Logo: "बामेटी – बिहार कृषि प्रबंधन एवं प्रसार प्रशिक्षण संस्थान",
  PM_Kisan_Logo: "पीएम किसान, भारत सरकार",

  pagination: {
    ariaLabel: "पृष्ठ नेविगेशन",
    previous: "पिछला पृष्ठ",
    next: "अगला पृष्ठ",
    goToPage: "पृष्ठ {{page}} पर जाएँ",
    showing: "दिखा रहे हैं",
    ofItems: "कुल {{count}} में से",
    itemsPerPage: "प्रति पृष्ठ आइटम",
  },
  IMD: "भारत मौसम विज्ञान विभाग",
  fb4a: "फेसबुक",
  ig4a: "इंस्टाग्राम",
};
